const tokens = {
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--🐼-animations-spin)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--🐼-animations-pulse)"
  },
  "radii.none": {
    "value": "0rem",
    "variable": "var(--🐼-radii-none)"
  },
  "radii.2xs": {
    "value": "0.25rem",
    "variable": "var(--🐼-radii-2xs)"
  },
  "radii.xs": {
    "value": "0.375rem",
    "variable": "var(--🐼-radii-xs)"
  },
  "radii.sm": {
    "value": "0.5rem",
    "variable": "var(--🐼-radii-sm)"
  },
  "radii.md": {
    "value": "0.75rem",
    "variable": "var(--🐼-radii-md)"
  },
  "radii.lg": {
    "value": "1rem",
    "variable": "var(--🐼-radii-lg)"
  },
  "radii.xl": {
    "value": "1.5rem",
    "variable": "var(--🐼-radii-xl)"
  },
  "radii.full": {
    "value": "62.5rem",
    "variable": "var(--🐼-radii-full)"
  },
  "borderWidths.0": {
    "value": "0rem",
    "variable": "var(--🐼-border-widths-0)"
  },
  "borderWidths.1": {
    "value": "0.0625rem",
    "variable": "var(--🐼-border-widths-1)"
  },
  "borderWidths.2": {
    "value": "0.125rem",
    "variable": "var(--🐼-border-widths-2)"
  },
  "borderWidths.3": {
    "value": "0.1875rem",
    "variable": "var(--🐼-border-widths-3)"
  },
  "borderWidths.4": {
    "value": "0.25rem",
    "variable": "var(--🐼-border-widths-4)"
  },
  "borderWidths.5": {
    "value": "0.3125rem",
    "variable": "var(--🐼-border-widths-5)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--🐼-spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--🐼-spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--🐼-spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--🐼-spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--🐼-spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--🐼-spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--🐼-spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--🐼-spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--🐼-spacing-8)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--🐼-spacing-10)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--🐼-spacing-12)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--🐼-spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--🐼-spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--🐼-spacing-24)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--🐼-spacing-32)"
  },
  "spacing.px": {
    "value": "0.0625rem",
    "variable": "var(--🐼-spacing-px)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--🐼-spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--🐼-spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--🐼-spacing-2\\.5)"
  },
  "fontWeights.regular": {
    "value": "400",
    "variable": "var(--🐼-font-weights-regular)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--🐼-font-weights-medium)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--🐼-font-weights-bold)"
  },
  "colors.whiteAlpha.50": {
    "value": "rgb(254 254 254 / 0.97)",
    "variable": "var(--🐼-colors-white-alpha-50)"
  },
  "colors.whiteAlpha.100": {
    "value": "rgb(254 254 255 / 0.94)",
    "variable": "var(--🐼-colors-white-alpha-100)"
  },
  "colors.whiteAlpha.200": {
    "value": "rgb(250 250 253 / 0.91)",
    "variable": "var(--🐼-colors-white-alpha-200)"
  },
  "colors.whiteAlpha.300": {
    "value": "rgb(251 251 254 / 0.86)",
    "variable": "var(--🐼-colors-white-alpha-300)"
  },
  "colors.whiteAlpha.400": {
    "value": "rgb(248 248 254 / 0.82)",
    "variable": "var(--🐼-colors-white-alpha-400)"
  },
  "colors.whiteAlpha.500": {
    "value": "rgb(244 244 252 / 0.77)",
    "variable": "var(--🐼-colors-white-alpha-500)"
  },
  "colors.whiteAlpha.600": {
    "value": "rgb(244 244 254 / 0.72)",
    "variable": "var(--🐼-colors-white-alpha-600)"
  },
  "colors.whiteAlpha.700": {
    "value": "rgb(241 241 255 / 0.65)",
    "variable": "var(--🐼-colors-white-alpha-700)"
  },
  "colors.whiteAlpha.800": {
    "value": "rgb(237 237 251 / 0.54)",
    "variable": "var(--🐼-colors-white-alpha-800)"
  },
  "colors.whiteAlpha.900": {
    "value": "rgb(232 232 250 / 0.47)",
    "variable": "var(--🐼-colors-white-alpha-900)"
  },
  "colors.whiteAlpha.1000": {
    "value": "rgb(231 231 251 / 0.41)",
    "variable": "var(--🐼-colors-white-alpha-1000)"
  },
  "colors.whiteAlpha.1100": {
    "value": "rgb(230 230 249 / 0.33)",
    "variable": "var(--🐼-colors-white-alpha-1100)"
  },
  "colors.whiteAlpha.1200": {
    "value": "rgb(227 227 251 / 0.22)",
    "variable": "var(--🐼-colors-white-alpha-1200)"
  },
  "colors.whiteAlpha.1300": {
    "value": "rgb(222 222 243 / 0.15)",
    "variable": "var(--🐼-colors-white-alpha-1300)"
  },
  "colors.whiteAlpha.1400": {
    "value": "rgb(219 219 240 / 0.1)",
    "variable": "var(--🐼-colors-white-alpha-1400)"
  },
  "colors.whiteAlpha.1500": {
    "value": "rgb(223 223 239 / 0.07)",
    "variable": "var(--🐼-colors-white-alpha-1500)"
  },
  "colors.blackAlpha.50": {
    "value": "rgb(55 55 55 / 0.04)",
    "variable": "var(--🐼-colors-black-alpha-50)"
  },
  "colors.blackAlpha.100": {
    "value": "rgb(26 26 41 / 0.07)",
    "variable": "var(--🐼-colors-black-alpha-100)"
  },
  "colors.blackAlpha.200": {
    "value": "rgb(10 10 37 / 0.11)",
    "variable": "var(--🐼-colors-black-alpha-200)"
  },
  "colors.blackAlpha.300": {
    "value": "rgb(12 12 26 / 0.14)",
    "variable": "var(--🐼-colors-black-alpha-300)"
  },
  "colors.blackAlpha.400": {
    "value": "rgb(5 5 30 / 0.2)",
    "variable": "var(--🐼-colors-black-alpha-400)"
  },
  "colors.blackAlpha.500": {
    "value": "rgb(3 3 31 / 0.25)",
    "variable": "var(--🐼-colors-black-alpha-500)"
  },
  "colors.blackAlpha.600": {
    "value": "rgb(7 7 32 / 0.31)",
    "variable": "var(--🐼-colors-black-alpha-600)"
  },
  "colors.blackAlpha.700": {
    "value": "rgb(5 5 29 / 0.38)",
    "variable": "var(--🐼-colors-black-alpha-700)"
  },
  "colors.blackAlpha.800": {
    "value": "rgb(4 4 20 / 0.49)",
    "variable": "var(--🐼-colors-black-alpha-800)"
  },
  "colors.blackAlpha.900": {
    "value": "rgb(3 3 19 / 0.56)",
    "variable": "var(--🐼-colors-black-alpha-900)"
  },
  "colors.blackAlpha.1000": {
    "value": "rgb(1 1 16 / 0.61)",
    "variable": "var(--🐼-colors-black-alpha-1000)"
  },
  "colors.blackAlpha.1100": {
    "value": "rgb(1 1 13 / 0.69)",
    "variable": "var(--🐼-colors-black-alpha-1100)"
  },
  "colors.blackAlpha.1200": {
    "value": "rgb(2 2 11 / 0.78)",
    "variable": "var(--🐼-colors-black-alpha-1200)"
  },
  "colors.blackAlpha.1300": {
    "value": "rgb(0 0 5 / 0.84)",
    "variable": "var(--🐼-colors-black-alpha-1300)"
  },
  "colors.blackAlpha.1400": {
    "value": "rgb(2 2 6 / 0.89)",
    "variable": "var(--🐼-colors-black-alpha-1400)"
  },
  "colors.blackAlpha.1500": {
    "value": "rgb(1 1 3 / 0.91)",
    "variable": "var(--🐼-colors-black-alpha-1500)"
  },
  "colors.grey.50": {
    "value": "rgb(247 247 247)",
    "variable": "var(--🐼-colors-grey-50)"
  },
  "colors.grey.100": {
    "value": "rgb(237 237 238)",
    "variable": "var(--🐼-colors-grey-100)"
  },
  "colors.grey.200": {
    "value": "rgb(231 231 233)",
    "variable": "var(--🐼-colors-grey-200)"
  },
  "colors.grey.300": {
    "value": "rgb(220 220 223)",
    "variable": "var(--🐼-colors-grey-300)"
  },
  "colors.grey.400": {
    "value": "rgb(205 205 210)",
    "variable": "var(--🐼-colors-grey-400)"
  },
  "colors.grey.500": {
    "value": "rgb(192 192 198)",
    "variable": "var(--🐼-colors-grey-500)"
  },
  "colors.grey.600": {
    "value": "rgb(178 178 186)",
    "variable": "var(--🐼-colors-grey-600)"
  },
  "colors.grey.700": {
    "value": "rgb(154 154 162)",
    "variable": "var(--🐼-colors-grey-700)"
  },
  "colors.grey.800": {
    "value": "rgb(132 132 140)",
    "variable": "var(--🐼-colors-grey-800)"
  },
  "colors.grey.900": {
    "value": "rgb(114 114 123)",
    "variable": "var(--🐼-colors-grey-900)"
  },
  "colors.grey.1000": {
    "value": "rgb(100 100 109)",
    "variable": "var(--🐼-colors-grey-1000)"
  },
  "colors.grey.1100": {
    "value": "rgb(80 80 88)",
    "variable": "var(--🐼-colors-grey-1100)"
  },
  "colors.grey.1200": {
    "value": "rgb(58 58 65)",
    "variable": "var(--🐼-colors-grey-1200)"
  },
  "colors.grey.1300": {
    "value": "rgb(41 41 45)",
    "variable": "var(--🐼-colors-grey-1300)"
  },
  "colors.grey.1400": {
    "value": "rgb(30 30 33)",
    "variable": "var(--🐼-colors-grey-1400)"
  },
  "colors.grey.1500": {
    "value": "rgb(24 24 26)",
    "variable": "var(--🐼-colors-grey-1500)"
  },
  "colors.amber.50": {
    "value": "rgb(254 250 231)",
    "variable": "var(--🐼-colors-amber-50)"
  },
  "colors.amber.100": {
    "value": "rgb(252 239 182)",
    "variable": "var(--🐼-colors-amber-100)"
  },
  "colors.amber.200": {
    "value": "rgb(251 231 157)",
    "variable": "var(--🐼-colors-amber-200)"
  },
  "colors.amber.300": {
    "value": "rgb(249 223 129)",
    "variable": "var(--🐼-colors-amber-300)"
  },
  "colors.amber.400": {
    "value": "rgb(247 211 99)",
    "variable": "var(--🐼-colors-amber-400)"
  },
  "colors.amber.500": {
    "value": "rgb(242 202 83)",
    "variable": "var(--🐼-colors-amber-500)"
  },
  "colors.amber.600": {
    "value": "rgb(235 191 71)",
    "variable": "var(--🐼-colors-amber-600)"
  },
  "colors.amber.700": {
    "value": "rgb(232 172 50)",
    "variable": "var(--🐼-colors-amber-700)"
  },
  "colors.amber.800": {
    "value": "rgb(227 154 30)",
    "variable": "var(--🐼-colors-amber-800)"
  },
  "colors.amber.900": {
    "value": "rgb(203 124 24)",
    "variable": "var(--🐼-colors-amber-900)"
  },
  "colors.amber.1000": {
    "value": "rgb(168 99 21)",
    "variable": "var(--🐼-colors-amber-1000)"
  },
  "colors.amber.1100": {
    "value": "rgb(135 77 24)",
    "variable": "var(--🐼-colors-amber-1100)"
  },
  "colors.amber.1200": {
    "value": "rgb(110 63 25)",
    "variable": "var(--🐼-colors-amber-1200)"
  },
  "colors.amber.1300": {
    "value": "rgb(92 51 25)",
    "variable": "var(--🐼-colors-amber-1300)"
  },
  "colors.amber.1400": {
    "value": "rgb(74 42 23)",
    "variable": "var(--🐼-colors-amber-1400)"
  },
  "colors.amber.1500": {
    "value": "rgb(61 36 21)",
    "variable": "var(--🐼-colors-amber-1500)"
  },
  "colors.amber.50A": {
    "value": "rgb(245 205 15 / 0.1)",
    "variable": "var(--🐼-colors-amber-50-a)"
  },
  "colors.amber.100A": {
    "value": "rgb(245 200 3 / 0.29)",
    "variable": "var(--🐼-colors-amber-100-a)"
  },
  "colors.amber.200A": {
    "value": "rgb(245 193 4 / 0.39)",
    "variable": "var(--🐼-colors-amber-200-a)"
  },
  "colors.amber.300A": {
    "value": "rgb(243 191 3 / 0.5)",
    "variable": "var(--🐼-colors-amber-300-a)"
  },
  "colors.amber.400A": {
    "value": "rgb(242 184 3 / 0.62)",
    "variable": "var(--🐼-colors-amber-400-a)"
  },
  "colors.amber.1200A": {
    "value": "rgb(249 138 46 / 0.42)",
    "variable": "var(--🐼-colors-amber-1200-a)"
  },
  "colors.amber.1300A": {
    "value": "rgb(253 133 54 / 0.34)",
    "variable": "var(--🐼-colors-amber-1300-a)"
  },
  "colors.amber.1400A": {
    "value": "rgb(250 131 58 / 0.27)",
    "variable": "var(--🐼-colors-amber-1400-a)"
  },
  "colors.amber.1500A": {
    "value": "rgb(245 132 60 / 0.22)",
    "variable": "var(--🐼-colors-amber-1500-a)"
  },
  "colors.blue.50": {
    "value": "rgb(240 245 255)",
    "variable": "var(--🐼-colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "rgb(219 233 255)",
    "variable": "var(--🐼-colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "rgb(191 218 255)",
    "variable": "var(--🐼-colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "rgb(164 203 255)",
    "variable": "var(--🐼-colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "rgb(141 193 255)",
    "variable": "var(--🐼-colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "rgb(114 179 255)",
    "variable": "var(--🐼-colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "rgb(92 168 255)",
    "variable": "var(--🐼-colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "rgb(67 155 255)",
    "variable": "var(--🐼-colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "rgb(42 140 252)",
    "variable": "var(--🐼-colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "rgb(13 118 242)",
    "variable": "var(--🐼-colors-blue-900)"
  },
  "colors.blue.1000": {
    "value": "rgb(0 101 223)",
    "variable": "var(--🐼-colors-blue-1000)"
  },
  "colors.blue.1100": {
    "value": "rgb(0 85 184)",
    "variable": "var(--🐼-colors-blue-1100)"
  },
  "colors.blue.1200": {
    "value": "rgb(7 71 147)",
    "variable": "var(--🐼-colors-blue-1200)"
  },
  "colors.blue.1300": {
    "value": "rgb(13 62 122)",
    "variable": "var(--🐼-colors-blue-1300)"
  },
  "colors.blue.1400": {
    "value": "rgb(16 51 96)",
    "variable": "var(--🐼-colors-blue-1400)"
  },
  "colors.blue.1500": {
    "value": "rgb(19 42 78)",
    "variable": "var(--🐼-colors-blue-1500)"
  },
  "colors.blue.100A": {
    "value": "rgb(15 108 255 / 0.15)",
    "variable": "var(--🐼-colors-blue-100-a)"
  },
  "colors.blue.200A": {
    "value": "rgb(9 113 255 / 0.26)",
    "variable": "var(--🐼-colors-blue-200-a)"
  },
  "colors.blue.300A": {
    "value": "rgb(2 111 255 / 0.36)",
    "variable": "var(--🐼-colors-blue-300-a)"
  },
  "colors.blue.400A": {
    "value": "rgb(2 117 255 / 0.45)",
    "variable": "var(--🐼-colors-blue-400-a)"
  },
  "colors.blue.50A": {
    "value": "rgb(5 88 255 / 0.06)",
    "variable": "var(--🐼-colors-blue-50-a)"
  },
  "colors.blue.1200A": {
    "value": "rgb(0 90 196 / 0.71)",
    "variable": "var(--🐼-colors-blue-1200-a)"
  },
  "colors.blue.1300A": {
    "value": "rgb(25 127 251 / 0.48)",
    "variable": "var(--🐼-colors-blue-1300-a)"
  },
  "colors.blue.1400A": {
    "value": "rgb(0 103 232 / 0.34)",
    "variable": "var(--🐼-colors-blue-1400-a)"
  },
  "colors.blue.1500A": {
    "value": "rgb(2 102 252 / 0.23)",
    "variable": "var(--🐼-colors-blue-1500-a)"
  },
  "colors.cyan.50": {
    "value": "rgb(240 247 255)",
    "variable": "var(--🐼-colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "rgb(215 236 254)",
    "variable": "var(--🐼-colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "rgb(185 226 254)",
    "variable": "var(--🐼-colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "rgb(155 217 254)",
    "variable": "var(--🐼-colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "rgb(124 210 253)",
    "variable": "var(--🐼-colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "rgb(92 203 253)",
    "variable": "var(--🐼-colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "rgb(56 195 250)",
    "variable": "var(--🐼-colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "rgb(29 184 243)",
    "variable": "var(--🐼-colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "rgb(10 173 228)",
    "variable": "var(--🐼-colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "rgb(0 153 204)",
    "variable": "var(--🐼-colors-cyan-900)"
  },
  "colors.cyan.1000": {
    "value": "rgb(1 124 172)",
    "variable": "var(--🐼-colors-cyan-1000)"
  },
  "colors.cyan.1100": {
    "value": "rgb(6 98 138)",
    "variable": "var(--🐼-colors-cyan-1100)"
  },
  "colors.cyan.1200": {
    "value": "rgb(11 77 111)",
    "variable": "var(--🐼-colors-cyan-1200)"
  },
  "colors.cyan.1300": {
    "value": "rgb(13 63 94)",
    "variable": "var(--🐼-colors-cyan-1300)"
  },
  "colors.cyan.1400": {
    "value": "rgb(15 54 82)",
    "variable": "var(--🐼-colors-cyan-1400)"
  },
  "colors.cyan.1500": {
    "value": "rgb(16 44 66)",
    "variable": "var(--🐼-colors-cyan-1500)"
  },
  "colors.cyan.50A": {
    "value": "rgb(5 122 255 / 0.06)",
    "variable": "var(--🐼-colors-cyan-50-a)"
  },
  "colors.cyan.100A": {
    "value": "rgb(5 136 249 / 0.16)",
    "variable": "var(--🐼-colors-cyan-100-a)"
  },
  "colors.cyan.200A": {
    "value": "rgb(5 151 251 / 0.28)",
    "variable": "var(--🐼-colors-cyan-200-a)"
  },
  "colors.cyan.300A": {
    "value": "rgb(5 160 253 / 0.4)",
    "variable": "var(--🐼-colors-cyan-300-a)"
  },
  "colors.cyan.400A": {
    "value": "rgb(3 168 251 / 0.52)",
    "variable": "var(--🐼-colors-cyan-400-a)"
  },
  "colors.cyan.1200A": {
    "value": "rgb(14 171 250 / 0.42)",
    "variable": "var(--🐼-colors-cyan-1200-a)"
  },
  "colors.cyan.1300A": {
    "value": "rgb(20 163 250 / 0.35)",
    "variable": "var(--🐼-colors-cyan-1300-a)"
  },
  "colors.cyan.1400A": {
    "value": "rgb(29 159 250 / 0.3)",
    "variable": "var(--🐼-colors-cyan-1400-a)"
  },
  "colors.cyan.1500A": {
    "value": "rgb(39 161 253 / 0.23)",
    "variable": "var(--🐼-colors-cyan-1500-a)"
  },
  "colors.emerald.50": {
    "value": "rgb(236 253 245)",
    "variable": "var(--🐼-colors-emerald-50)"
  },
  "colors.emerald.100": {
    "value": "rgb(209 250 229)",
    "variable": "var(--🐼-colors-emerald-100)"
  },
  "colors.emerald.200": {
    "value": "rgb(167 243 208)",
    "variable": "var(--🐼-colors-emerald-200)"
  },
  "colors.emerald.300": {
    "value": "rgb(137 237 194)",
    "variable": "var(--🐼-colors-emerald-300)"
  },
  "colors.emerald.400": {
    "value": "rgb(110 231 183)",
    "variable": "var(--🐼-colors-emerald-400)"
  },
  "colors.emerald.500": {
    "value": "rgb(81 221 169)",
    "variable": "var(--🐼-colors-emerald-500)"
  },
  "colors.emerald.600": {
    "value": "rgb(52 211 153)",
    "variable": "var(--🐼-colors-emerald-600)"
  },
  "colors.emerald.700": {
    "value": "rgb(32 199 139)",
    "variable": "var(--🐼-colors-emerald-700)"
  },
  "colors.emerald.800": {
    "value": "rgb(16 185 129)",
    "variable": "var(--🐼-colors-emerald-800)"
  },
  "colors.emerald.900": {
    "value": "rgb(5 150 105)",
    "variable": "var(--🐼-colors-emerald-900)"
  },
  "colors.emerald.1000": {
    "value": "rgb(4 120 87)",
    "variable": "var(--🐼-colors-emerald-1000)"
  },
  "colors.emerald.1100": {
    "value": "rgb(6 95 70)",
    "variable": "var(--🐼-colors-emerald-1100)"
  },
  "colors.emerald.1200": {
    "value": "rgb(8 78 60)",
    "variable": "var(--🐼-colors-emerald-1200)"
  },
  "colors.emerald.1300": {
    "value": "rgb(10 65 50)",
    "variable": "var(--🐼-colors-emerald-1300)"
  },
  "colors.emerald.1400": {
    "value": "rgb(9 57 45)",
    "variable": "var(--🐼-colors-emerald-1400)"
  },
  "colors.emerald.1500": {
    "value": "rgb(11 50 41)",
    "variable": "var(--🐼-colors-emerald-1500)"
  },
  "colors.emerald.50A": {
    "value": "rgb(18 230 130 / 0.08)",
    "variable": "var(--🐼-colors-emerald-50-a)"
  },
  "colors.emerald.100A": {
    "value": "rgb(13 229 118 / 0.19)",
    "variable": "var(--🐼-colors-emerald-100-a)"
  },
  "colors.emerald.200A": {
    "value": "rgb(4 221 121 / 0.35)",
    "variable": "var(--🐼-colors-emerald-200-a)"
  },
  "colors.emerald.300A": {
    "value": "rgb(4 217 125 / 0.47)",
    "variable": "var(--🐼-colors-emerald-300-a)"
  },
  "colors.emerald.400A": {
    "value": "rgb(1 213 129 / 0.57)",
    "variable": "var(--🐼-colors-emerald-400-a)"
  },
  "colors.emerald.1200A": {
    "value": "rgb(6 247 182 / 0.29)",
    "variable": "var(--🐼-colors-emerald-1200-a)"
  },
  "colors.emerald.1300A": {
    "value": "rgb(13 252 184 / 0.23)",
    "variable": "var(--🐼-colors-emerald-1300-a)"
  },
  "colors.emerald.1400A": {
    "value": "rgb(9 249 185 / 0.2)",
    "variable": "var(--🐼-colors-emerald-1400-a)"
  },
  "colors.emerald.1500A": {
    "value": "rgb(21 250 192 / 0.17)",
    "variable": "var(--🐼-colors-emerald-1500-a)"
  },
  "colors.fuchsia.50": {
    "value": "rgb(252 240 255)",
    "variable": "var(--🐼-colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    "value": "rgb(248 224 255)",
    "variable": "var(--🐼-colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    "value": "rgb(245 208 254)",
    "variable": "var(--🐼-colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    "value": "rgb(240 188 253)",
    "variable": "var(--🐼-colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    "value": "rgb(239 171 252)",
    "variable": "var(--🐼-colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    "value": "rgb(234 148 250)",
    "variable": "var(--🐼-colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    "value": "rgb(232 121 249)",
    "variable": "var(--🐼-colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    "value": "rgb(227 98 246)",
    "variable": "var(--🐼-colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    "value": "rgb(217 70 239)",
    "variable": "var(--🐼-colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    "value": "rgb(192 38 211)",
    "variable": "var(--🐼-colors-fuchsia-900)"
  },
  "colors.fuchsia.1000": {
    "value": "rgb(162 28 175)",
    "variable": "var(--🐼-colors-fuchsia-1000)"
  },
  "colors.fuchsia.1100": {
    "value": "rgb(134 25 143)",
    "variable": "var(--🐼-colors-fuchsia-1100)"
  },
  "colors.fuchsia.1200": {
    "value": "rgb(112 26 117)",
    "variable": "var(--🐼-colors-fuchsia-1200)"
  },
  "colors.fuchsia.1300": {
    "value": "rgb(96 28 100)",
    "variable": "var(--🐼-colors-fuchsia-1300)"
  },
  "colors.fuchsia.1400": {
    "value": "rgb(77 27 80)",
    "variable": "var(--🐼-colors-fuchsia-1400)"
  },
  "colors.fuchsia.1500": {
    "value": "rgb(60 24 62)",
    "variable": "var(--🐼-colors-fuchsia-1500)"
  },
  "colors.fuchsia.50A": {
    "value": "rgb(205 5 255 / 0.06)",
    "variable": "var(--🐼-colors-fuchsia-50-a)"
  },
  "colors.fuchsia.100A": {
    "value": "rgb(201 17 255 / 0.13)",
    "variable": "var(--🐼-colors-fuchsia-100-a)"
  },
  "colors.fuchsia.200A": {
    "value": "rgb(202 8 250 / 0.19)",
    "variable": "var(--🐼-colors-fuchsia-200-a)"
  },
  "colors.fuchsia.300A": {
    "value": "rgb(199 7 248 / 0.27)",
    "variable": "var(--🐼-colors-fuchsia-300-a)"
  },
  "colors.fuchsia.400A": {
    "value": "rgb(207 0 246 / 0.33)",
    "variable": "var(--🐼-colors-fuchsia-400-a)"
  },
  "colors.fuchsia.1200A": {
    "value": "rgb(243 48 253 / 0.44)",
    "variable": "var(--🐼-colors-fuchsia-1200-a)"
  },
  "colors.fuchsia.1300A": {
    "value": "rgb(244 60 253 / 0.37)",
    "variable": "var(--🐼-colors-fuchsia-1300-a)"
  },
  "colors.fuchsia.1400A": {
    "value": "rgb(243 71 251 / 0.29)",
    "variable": "var(--🐼-colors-fuchsia-1400-a)"
  },
  "colors.fuchsia.1500A": {
    "value": "rgb(241 77 246 / 0.22)",
    "variable": "var(--🐼-colors-fuchsia-1500-a)"
  },
  "colors.green.50": {
    "value": "rgb(240 253 244)",
    "variable": "var(--🐼-colors-green-50)"
  },
  "colors.green.100": {
    "value": "rgb(213 251 226)",
    "variable": "var(--🐼-colors-green-100)"
  },
  "colors.green.200": {
    "value": "rgb(187 247 208)",
    "variable": "var(--🐼-colors-green-200)"
  },
  "colors.green.300": {
    "value": "rgb(157 243 187)",
    "variable": "var(--🐼-colors-green-300)"
  },
  "colors.green.400": {
    "value": "rgb(134 239 172)",
    "variable": "var(--🐼-colors-green-400)"
  },
  "colors.green.500": {
    "value": "rgb(104 232 150)",
    "variable": "var(--🐼-colors-green-500)"
  },
  "colors.green.600": {
    "value": "rgb(74 222 128)",
    "variable": "var(--🐼-colors-green-600)"
  },
  "colors.green.700": {
    "value": "rgb(51 212 110)",
    "variable": "var(--🐼-colors-green-700)"
  },
  "colors.green.800": {
    "value": "rgb(34 197 94)",
    "variable": "var(--🐼-colors-green-800)"
  },
  "colors.green.900": {
    "value": "rgb(22 163 74)",
    "variable": "var(--🐼-colors-green-900)"
  },
  "colors.green.1000": {
    "value": "rgb(21 128 61)",
    "variable": "var(--🐼-colors-green-1000)"
  },
  "colors.green.1100": {
    "value": "rgb(22 101 52)",
    "variable": "var(--🐼-colors-green-1100)"
  },
  "colors.green.1200": {
    "value": "rgb(23 83 47)",
    "variable": "var(--🐼-colors-green-1200)"
  },
  "colors.green.1300": {
    "value": "rgb(24 68 41)",
    "variable": "var(--🐼-colors-green-1300)"
  },
  "colors.green.1400": {
    "value": "rgb(24 58 38)",
    "variable": "var(--🐼-colors-green-1400)"
  },
  "colors.green.1500": {
    "value": "rgb(20 46 31)",
    "variable": "var(--🐼-colors-green-1500)"
  },
  "colors.green.50A": {
    "value": "rgb(5 222 72 / 0.06)",
    "variable": "var(--🐼-colors-green-50-a)"
  },
  "colors.green.100A": {
    "value": "rgb(8 231 84 / 0.17)",
    "variable": "var(--🐼-colors-green-100-a)"
  },
  "colors.green.200A": {
    "value": "rgb(3 225 81 / 0.27)",
    "variable": "var(--🐼-colors-green-200-a)"
  },
  "colors.green.300A": {
    "value": "rgb(4 224 81 / 0.39)",
    "variable": "var(--🐼-colors-green-300-a)"
  },
  "colors.green.400A": {
    "value": "rgb(3 222 82 / 0.48)",
    "variable": "var(--🐼-colors-green-400-a)"
  },
  "colors.green.1200A": {
    "value": "rgb(54 248 129 / 0.31)",
    "variable": "var(--🐼-colors-green-1200-a)"
  },
  "colors.green.1300A": {
    "value": "rgb(72 255 139 / 0.24)",
    "variable": "var(--🐼-colors-green-1300-a)"
  },
  "colors.green.1400A": {
    "value": "rgb(84 254 150 / 0.2)",
    "variable": "var(--🐼-colors-green-1400-a)"
  },
  "colors.green.1500A": {
    "value": "rgb(78 240 141 / 0.16)",
    "variable": "var(--🐼-colors-green-1500-a)"
  },
  "colors.indigo.50": {
    "value": "rgb(240 243 255)",
    "variable": "var(--🐼-colors-indigo-50)"
  },
  "colors.indigo.100": {
    "value": "rgb(222 230 255)",
    "variable": "var(--🐼-colors-indigo-100)"
  },
  "colors.indigo.200": {
    "value": "rgb(199 210 254)",
    "variable": "var(--🐼-colors-indigo-200)"
  },
  "colors.indigo.300": {
    "value": "rgb(182 195 254)",
    "variable": "var(--🐼-colors-indigo-300)"
  },
  "colors.indigo.400": {
    "value": "rgb(165 180 252)",
    "variable": "var(--🐼-colors-indigo-400)"
  },
  "colors.indigo.500": {
    "value": "rgb(148 163 251)",
    "variable": "var(--🐼-colors-indigo-500)"
  },
  "colors.indigo.600": {
    "value": "rgb(129 140 248)",
    "variable": "var(--🐼-colors-indigo-600)"
  },
  "colors.indigo.700": {
    "value": "rgb(114 122 246)",
    "variable": "var(--🐼-colors-indigo-700)"
  },
  "colors.indigo.800": {
    "value": "rgb(94 97 241)",
    "variable": "var(--🐼-colors-indigo-800)"
  },
  "colors.indigo.900": {
    "value": "rgb(80 70 231)",
    "variable": "var(--🐼-colors-indigo-900)"
  },
  "colors.indigo.1000": {
    "value": "rgb(68 56 204)",
    "variable": "var(--🐼-colors-indigo-1000)"
  },
  "colors.indigo.1100": {
    "value": "rgb(57 49 165)",
    "variable": "var(--🐼-colors-indigo-1100)"
  },
  "colors.indigo.1200": {
    "value": "rgb(51 47 137)",
    "variable": "var(--🐼-colors-indigo-1200)"
  },
  "colors.indigo.1300": {
    "value": "rgb(44 43 113)",
    "variable": "var(--🐼-colors-indigo-1300)"
  },
  "colors.indigo.1400": {
    "value": "rgb(39 39 94)",
    "variable": "var(--🐼-colors-indigo-1400)"
  },
  "colors.indigo.1500": {
    "value": "rgb(34 35 78)",
    "variable": "var(--🐼-colors-indigo-1500)"
  },
  "colors.indigo.50A": {
    "value": "rgb(5 55 255 / 0.06)",
    "variable": "var(--🐼-colors-indigo-50-a)"
  },
  "colors.indigo.100A": {
    "value": "rgb(1 63 255 / 0.13)",
    "variable": "var(--🐼-colors-indigo-100-a)"
  },
  "colors.indigo.200A": {
    "value": "rgb(0 50 250 / 0.22)",
    "variable": "var(--🐼-colors-indigo-200-a)"
  },
  "colors.indigo.300A": {
    "value": "rgb(3 48 252 / 0.29)",
    "variable": "var(--🐼-colors-indigo-300-a)"
  },
  "colors.indigo.400A": {
    "value": "rgb(5 47 247 / 0.36)",
    "variable": "var(--🐼-colors-indigo-400-a)"
  },
  "colors.indigo.1200A": {
    "value": "rgb(90 82 254 / 0.52)",
    "variable": "var(--🐼-colors-indigo-1200-a)"
  },
  "colors.indigo.1300A": {
    "value": "rgb(90 88 250 / 0.43)",
    "variable": "var(--🐼-colors-indigo-1300-a)"
  },
  "colors.indigo.1400A": {
    "value": "rgb(95 95 250 / 0.35)",
    "variable": "var(--🐼-colors-indigo-1400-a)"
  },
  "colors.indigo.1500A": {
    "value": "rgb(98 102 253 / 0.28)",
    "variable": "var(--🐼-colors-indigo-1500-a)"
  },
  "colors.lime.50": {
    "value": "rgb(245 254 226)",
    "variable": "var(--🐼-colors-lime-50)"
  },
  "colors.lime.100": {
    "value": "rgb(230 251 187)",
    "variable": "var(--🐼-colors-lime-100)"
  },
  "colors.lime.200": {
    "value": "rgb(217 249 157)",
    "variable": "var(--🐼-colors-lime-200)"
  },
  "colors.lime.300": {
    "value": "rgb(205 247 125)",
    "variable": "var(--🐼-colors-lime-300)"
  },
  "colors.lime.400": {
    "value": "rgb(190 242 100)",
    "variable": "var(--🐼-colors-lime-400)"
  },
  "colors.lime.500": {
    "value": "rgb(176 236 73)",
    "variable": "var(--🐼-colors-lime-500)"
  },
  "colors.lime.600": {
    "value": "rgb(163 230 53)",
    "variable": "var(--🐼-colors-lime-600)"
  },
  "colors.lime.700": {
    "value": "rgb(149 218 37)",
    "variable": "var(--🐼-colors-lime-700)"
  },
  "colors.lime.800": {
    "value": "rgb(130 200 22)",
    "variable": "var(--🐼-colors-lime-800)"
  },
  "colors.lime.900": {
    "value": "rgb(101 163 13)",
    "variable": "var(--🐼-colors-lime-900)"
  },
  "colors.lime.1000": {
    "value": "rgb(77 124 15)",
    "variable": "var(--🐼-colors-lime-1000)"
  },
  "colors.lime.1100": {
    "value": "rgb(63 98 18)",
    "variable": "var(--🐼-colors-lime-1100)"
  },
  "colors.lime.1200": {
    "value": "rgb(54 83 21)",
    "variable": "var(--🐼-colors-lime-1200)"
  },
  "colors.lime.1300": {
    "value": "rgb(46 68 22)",
    "variable": "var(--🐼-colors-lime-1300)"
  },
  "colors.lime.1400": {
    "value": "rgb(40 56 20)",
    "variable": "var(--🐼-colors-lime-1400)"
  },
  "colors.lime.1500": {
    "value": "rgb(32 46 18)",
    "variable": "var(--🐼-colors-lime-1500)"
  },
  "colors.lime.50A": {
    "value": "rgb(172 247 13 / 0.12)",
    "variable": "var(--🐼-colors-lime-50-a)"
  },
  "colors.lime.100A": {
    "value": "rgb(162 240 3 / 0.27)",
    "variable": "var(--🐼-colors-lime-100-a)"
  },
  "colors.lime.200A": {
    "value": "rgb(158 240 4 / 0.39)",
    "variable": "var(--🐼-colors-lime-200-a)"
  },
  "colors.lime.300A": {
    "value": "rgb(157 239 0 / 0.51)",
    "variable": "var(--🐼-colors-lime-300-a)"
  },
  "colors.lime.400A": {
    "value": "rgb(148 234 1 / 0.61)",
    "variable": "var(--🐼-colors-lime-400-a)"
  },
  "colors.lime.1200A": {
    "value": "rgb(154 248 45 / 0.31)",
    "variable": "var(--🐼-colors-lime-1200-a)"
  },
  "colors.lime.1300A": {
    "value": "rgb(163 255 60 / 0.24)",
    "variable": "var(--🐼-colors-lime-1300-a)"
  },
  "colors.lime.1400A": {
    "value": "rgb(164 244 60 / 0.2)",
    "variable": "var(--🐼-colors-lime-1400-a)"
  },
  "colors.lime.1500A": {
    "value": "rgb(153 240 60 / 0.16)",
    "variable": "var(--🐼-colors-lime-1500-a)"
  },
  "colors.magenta.50": {
    "value": "rgb(255 241 242)",
    "variable": "var(--🐼-colors-magenta-50)"
  },
  "colors.magenta.100": {
    "value": "rgb(255 228 230)",
    "variable": "var(--🐼-colors-magenta-100)"
  },
  "colors.magenta.200": {
    "value": "rgb(254 205 210)",
    "variable": "var(--🐼-colors-magenta-200)"
  },
  "colors.magenta.300": {
    "value": "rgb(254 183 192)",
    "variable": "var(--🐼-colors-magenta-300)"
  },
  "colors.magenta.400": {
    "value": "rgb(253 164 175)",
    "variable": "var(--🐼-colors-magenta-400)"
  },
  "colors.magenta.500": {
    "value": "rgb(253 142 155)",
    "variable": "var(--🐼-colors-magenta-500)"
  },
  "colors.magenta.600": {
    "value": "rgb(251 113 132)",
    "variable": "var(--🐼-colors-magenta-600)"
  },
  "colors.magenta.700": {
    "value": "rgb(249 89 112)",
    "variable": "var(--🐼-colors-magenta-700)"
  },
  "colors.magenta.800": {
    "value": "rgb(244 63 94)",
    "variable": "var(--🐼-colors-magenta-800)"
  },
  "colors.magenta.900": {
    "value": "rgb(225 29 72)",
    "variable": "var(--🐼-colors-magenta-900)"
  },
  "colors.magenta.1000": {
    "value": "rgb(190 18 60)",
    "variable": "var(--🐼-colors-magenta-1000)"
  },
  "colors.magenta.1100": {
    "value": "rgb(159 18 57)",
    "variable": "var(--🐼-colors-magenta-1100)"
  },
  "colors.magenta.1200": {
    "value": "rgb(136 19 53)",
    "variable": "var(--🐼-colors-magenta-1200)"
  },
  "colors.magenta.1300": {
    "value": "rgb(118 20 48)",
    "variable": "var(--🐼-colors-magenta-1300)"
  },
  "colors.magenta.1400": {
    "value": "rgb(93 21 42)",
    "variable": "var(--🐼-colors-magenta-1400)"
  },
  "colors.magenta.1500": {
    "value": "rgb(74 23 37)",
    "variable": "var(--🐼-colors-magenta-1500)"
  },
  "colors.magenta.50A": {
    "value": "rgb(255 22 38 / 0.06)",
    "variable": "var(--🐼-colors-magenta-50-a)"
  },
  "colors.magenta.100A": {
    "value": "rgb(255 10 28 / 0.11)",
    "variable": "var(--🐼-colors-magenta-100-a)"
  },
  "colors.magenta.200A": {
    "value": "rgb(250 5 30 / 0.2)",
    "variable": "var(--🐼-colors-magenta-200-a)"
  },
  "colors.magenta.300A": {
    "value": "rgb(252 7 38 / 0.29)",
    "variable": "var(--🐼-colors-magenta-300-a)"
  },
  "colors.magenta.400A": {
    "value": "rgb(249 2 33 / 0.36)",
    "variable": "var(--🐼-colors-magenta-400-a)"
  },
  "colors.magenta.1200A": {
    "value": "rgb(253 28 93 / 0.52)",
    "variable": "var(--🐼-colors-magenta-1200-a)"
  },
  "colors.magenta.1300A": {
    "value": "rgb(251 33 94 / 0.45)",
    "variable": "var(--🐼-colors-magenta-1300-a)"
  },
  "colors.magenta.1400A": {
    "value": "rgb(249 43 101 / 0.35)",
    "variable": "var(--🐼-colors-magenta-1400-a)"
  },
  "colors.magenta.1500A": {
    "value": "rgb(250 61 110 / 0.27)",
    "variable": "var(--🐼-colors-magenta-1500-a)"
  },
  "colors.orange.50": {
    "value": "rgb(255 247 237)",
    "variable": "var(--🐼-colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "rgb(255 233 204)",
    "variable": "var(--🐼-colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "rgb(254 221 178)",
    "variable": "var(--🐼-colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "rgb(254 203 143)",
    "variable": "var(--🐼-colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "rgb(253 186 116)",
    "variable": "var(--🐼-colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "rgb(253 171 85)",
    "variable": "var(--🐼-colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "rgb(251 153 60)",
    "variable": "var(--🐼-colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "rgb(251 134 39)",
    "variable": "var(--🐼-colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "rgb(249 115 22)",
    "variable": "var(--🐼-colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "rgb(234 88 12)",
    "variable": "var(--🐼-colors-orange-900)"
  },
  "colors.orange.1000": {
    "value": "rgb(194 65 12)",
    "variable": "var(--🐼-colors-orange-1000)"
  },
  "colors.orange.1100": {
    "value": "rgb(154 50 16)",
    "variable": "var(--🐼-colors-orange-1100)"
  },
  "colors.orange.1200": {
    "value": "rgb(124 44 20)",
    "variable": "var(--🐼-colors-orange-1200)"
  },
  "colors.orange.1300": {
    "value": "rgb(106 41 22)",
    "variable": "var(--🐼-colors-orange-1300)"
  },
  "colors.orange.1400": {
    "value": "rgb(88 36 22)",
    "variable": "var(--🐼-colors-orange-1400)"
  },
  "colors.orange.1500": {
    "value": "rgb(68 29 19)",
    "variable": "var(--🐼-colors-orange-1500)"
  },
  "colors.orange.50A": {
    "value": "rgb(255 155 30 / 0.08)",
    "variable": "var(--🐼-colors-orange-50-a)"
  },
  "colors.orange.100A": {
    "value": "rgb(255 145 0 / 0.2)",
    "variable": "var(--🐼-colors-orange-100-a)"
  },
  "colors.orange.200A": {
    "value": "rgb(252 145 7 / 0.31)",
    "variable": "var(--🐼-colors-orange-200-a)"
  },
  "colors.orange.300A": {
    "value": "rgb(253 137 0 / 0.44)",
    "variable": "var(--🐼-colors-orange-300-a)"
  },
  "colors.orange.400A": {
    "value": "rgb(251 130 2 / 0.55)",
    "variable": "var(--🐼-colors-orange-400-a)"
  },
  "colors.orange.1200A": {
    "value": "rgb(254 83 31 / 0.47)",
    "variable": "var(--🐼-colors-orange-1200-a)"
  },
  "colors.orange.1300A": {
    "value": "rgb(251 89 40 / 0.4)",
    "variable": "var(--🐼-colors-orange-1300-a)"
  },
  "colors.orange.1400A": {
    "value": "rgb(248 91 46 / 0.33)",
    "variable": "var(--🐼-colors-orange-1400-a)"
  },
  "colors.orange.1500A": {
    "value": "rgb(255 92 48 / 0.24)",
    "variable": "var(--🐼-colors-orange-1500-a)"
  },
  "colors.peach.50": {
    "value": "rgb(254 244 241)",
    "variable": "var(--🐼-colors-peach-50)"
  },
  "colors.peach.100": {
    "value": "rgb(255 228 219)",
    "variable": "var(--🐼-colors-peach-100)"
  },
  "colors.peach.200": {
    "value": "rgb(253 216 206)",
    "variable": "var(--🐼-colors-peach-200)"
  },
  "colors.peach.300": {
    "value": "rgb(252 197 182)",
    "variable": "var(--🐼-colors-peach-300)"
  },
  "colors.peach.400": {
    "value": "rgb(252 182 163)",
    "variable": "var(--🐼-colors-peach-400)"
  },
  "colors.peach.500": {
    "value": "rgb(250 166 142)",
    "variable": "var(--🐼-colors-peach-500)"
  },
  "colors.peach.600": {
    "value": "rgb(246 146 118)",
    "variable": "var(--🐼-colors-peach-600)"
  },
  "colors.peach.700": {
    "value": "rgb(237 122 91)",
    "variable": "var(--🐼-colors-peach-700)"
  },
  "colors.peach.800": {
    "value": "rgb(228 106 73)",
    "variable": "var(--🐼-colors-peach-800)"
  },
  "colors.peach.900": {
    "value": "rgb(214 83 52)",
    "variable": "var(--🐼-colors-peach-900)"
  },
  "colors.peach.1000": {
    "value": "rgb(188 63 36)",
    "variable": "var(--🐼-colors-peach-1000)"
  },
  "colors.peach.1100": {
    "value": "rgb(158 52 29)",
    "variable": "var(--🐼-colors-peach-1100)"
  },
  "colors.peach.1200": {
    "value": "rgb(126 48 33)",
    "variable": "var(--🐼-colors-peach-1200)"
  },
  "colors.peach.1300": {
    "value": "rgb(103 43 32)",
    "variable": "var(--🐼-colors-peach-1300)"
  },
  "colors.peach.1400": {
    "value": "rgb(85 36 27)",
    "variable": "var(--🐼-colors-peach-1400)"
  },
  "colors.peach.1500": {
    "value": "rgb(67 28 20)",
    "variable": "var(--🐼-colors-peach-1500)"
  },
  "colors.peach.50A": {
    "value": "rgb(238 72 22 / 0.06)",
    "variable": "var(--🐼-colors-peach-50-a)"
  },
  "colors.peach.100A": {
    "value": "rgb(255 75 15 / 0.15)",
    "variable": "var(--🐼-colors-peach-100-a)"
  },
  "colors.peach.200A": {
    "value": "rgb(245 60 10 / 0.2)",
    "variable": "var(--🐼-colors-peach-200-a)"
  },
  "colors.peach.300A": {
    "value": "rgb(245 55 3 / 0.29)",
    "variable": "var(--🐼-colors-peach-300-a)"
  },
  "colors.peach.400A": {
    "value": "rgb(247 58 6 / 0.37)",
    "variable": "var(--🐼-colors-peach-400-a)"
  },
  "colors.peach.1200A": {
    "value": "rgb(253 90 58 / 0.48)",
    "variable": "var(--🐼-colors-peach-1200-a)"
  },
  "colors.peach.1300A": {
    "value": "rgb(250 96 66 / 0.39)",
    "variable": "var(--🐼-colors-peach-1300-a)"
  },
  "colors.peach.1400A": {
    "value": "rgb(254 96 65 / 0.31)",
    "variable": "var(--🐼-colors-peach-1400-a)"
  },
  "colors.peach.1500A": {
    "value": "rgb(251 88 52 / 0.24)",
    "variable": "var(--🐼-colors-peach-1500-a)"
  },
  "colors.pink.50": {
    "value": "rgb(253 242 248)",
    "variable": "var(--🐼-colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "rgb(252 228 241)",
    "variable": "var(--🐼-colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "rgb(251 209 233)",
    "variable": "var(--🐼-colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "rgb(251 189 224)",
    "variable": "var(--🐼-colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "rgb(251 169 213)",
    "variable": "var(--🐼-colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "rgb(249 146 202)",
    "variable": "var(--🐼-colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "rgb(247 115 184)",
    "variable": "var(--🐼-colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "rgb(244 94 172)",
    "variable": "var(--🐼-colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "rgb(236 67 150)",
    "variable": "var(--🐼-colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "rgb(219 39 119)",
    "variable": "var(--🐼-colors-pink-900)"
  },
  "colors.pink.1000": {
    "value": "rgb(190 24 93)",
    "variable": "var(--🐼-colors-pink-1000)"
  },
  "colors.pink.1100": {
    "value": "rgb(157 23 77)",
    "variable": "var(--🐼-colors-pink-1100)"
  },
  "colors.pink.1200": {
    "value": "rgb(131 24 67)",
    "variable": "var(--🐼-colors-pink-1200)"
  },
  "colors.pink.1300": {
    "value": "rgb(107 26 59)",
    "variable": "var(--🐼-colors-pink-1300)"
  },
  "colors.pink.1400": {
    "value": "rgb(89 24 50)",
    "variable": "var(--🐼-colors-pink-1400)"
  },
  "colors.pink.1500": {
    "value": "rgb(67 25 42)",
    "variable": "var(--🐼-colors-pink-1500)"
  },
  "colors.pink.50A": {
    "value": "rgb(222 38 138 / 0.06)",
    "variable": "var(--🐼-colors-pink-50-a)"
  },
  "colors.pink.100A": {
    "value": "rgb(228 10 128 / 0.11)",
    "variable": "var(--🐼-colors-pink-100-a)"
  },
  "colors.pink.200A": {
    "value": "rgb(234 13 139 / 0.19)",
    "variable": "var(--🐼-colors-pink-200-a)"
  },
  "colors.pink.300A": {
    "value": "rgb(240 1 136 / 0.26)",
    "variable": "var(--🐼-colors-pink-300-a)"
  },
  "colors.pink.400A": {
    "value": "rgb(243 2 131 / 0.34)",
    "variable": "var(--🐼-colors-pink-400-a)"
  },
  "colors.pink.1200A": {
    "value": "rgb(253 39 124 / 0.5)",
    "variable": "var(--🐼-colors-pink-1200-a)"
  },
  "colors.pink.1300A": {
    "value": "rgb(254 52 133 / 0.4)",
    "variable": "var(--🐼-colors-pink-1300-a)"
  },
  "colors.pink.1400A": {
    "value": "rgb(251 54 131 / 0.33)",
    "variable": "var(--🐼-colors-pink-1400-a)"
  },
  "colors.pink.1500A": {
    "value": "rgb(251 76 143 / 0.24)",
    "variable": "var(--🐼-colors-pink-1500-a)"
  },
  "colors.purple.50": {
    "value": "rgb(247 240 255)",
    "variable": "var(--🐼-colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "rgb(239 224 255)",
    "variable": "var(--🐼-colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "rgb(233 213 255)",
    "variable": "var(--🐼-colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "rgb(224 196 255)",
    "variable": "var(--🐼-colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "rgb(216 180 254)",
    "variable": "var(--🐼-colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "rgb(204 157 254)",
    "variable": "var(--🐼-colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "rgb(192 132 252)",
    "variable": "var(--🐼-colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "rgb(181 110 251)",
    "variable": "var(--🐼-colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "rgb(168 85 247)",
    "variable": "var(--🐼-colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "rgb(147 51 234)",
    "variable": "var(--🐼-colors-purple-900)"
  },
  "colors.purple.1000": {
    "value": "rgb(126 34 206)",
    "variable": "var(--🐼-colors-purple-1000)"
  },
  "colors.purple.1100": {
    "value": "rgb(105 30 168)",
    "variable": "var(--🐼-colors-purple-1100)"
  },
  "colors.purple.1200": {
    "value": "rgb(94 32 141)",
    "variable": "var(--🐼-colors-purple-1200)"
  },
  "colors.purple.1300": {
    "value": "rgb(83 31 123)",
    "variable": "var(--🐼-colors-purple-1300)"
  },
  "colors.purple.1400": {
    "value": "rgb(65 28 95)",
    "variable": "var(--🐼-colors-purple-1400)"
  },
  "colors.purple.1500": {
    "value": "rgb(54 26 76)",
    "variable": "var(--🐼-colors-purple-1500)"
  },
  "colors.purple.50A": {
    "value": "rgb(122 5 255 / 0.06)",
    "variable": "var(--🐼-colors-purple-50-a)"
  },
  "colors.purple.100A": {
    "value": "rgb(132 17 255 / 0.13)",
    "variable": "var(--🐼-colors-purple-100-a)"
  },
  "colors.purple.200A": {
    "value": "rgb(126 8 255 / 0.17)",
    "variable": "var(--🐼-colors-purple-200-a)"
  },
  "colors.purple.300A": {
    "value": "rgb(126 9 255 / 0.24)",
    "variable": "var(--🐼-colors-purple-300-a)"
  },
  "colors.purple.400A": {
    "value": "rgb(125 5 252 / 0.3)",
    "variable": "var(--🐼-colors-purple-400-a)"
  },
  "colors.purple.1200A": {
    "value": "rgb(166 52 253 / 0.54)",
    "variable": "var(--🐼-colors-purple-1200-a)"
  },
  "colors.purple.1300A": {
    "value": "rgb(166 56 250 / 0.47)",
    "variable": "var(--🐼-colors-purple-1300-a)"
  },
  "colors.purple.1400A": {
    "value": "rgb(169 63 253 / 0.35)",
    "variable": "var(--🐼-colors-purple-1400-a)"
  },
  "colors.purple.1500A": {
    "value": "rgb(176 72 254 / 0.27)",
    "variable": "var(--🐼-colors-purple-1500-a)"
  },
  "colors.red.50": {
    "value": "rgb(254 244 242)",
    "variable": "var(--🐼-colors-red-50)"
  },
  "colors.red.100": {
    "value": "rgb(254 227 224)",
    "variable": "var(--🐼-colors-red-100)"
  },
  "colors.red.200": {
    "value": "rgb(254 208 202)",
    "variable": "var(--🐼-colors-red-200)"
  },
  "colors.red.300": {
    "value": "rgb(254 189 182)",
    "variable": "var(--🐼-colors-red-300)"
  },
  "colors.red.400": {
    "value": "rgb(254 171 162)",
    "variable": "var(--🐼-colors-red-400)"
  },
  "colors.red.500": {
    "value": "rgb(252 148 139)",
    "variable": "var(--🐼-colors-red-500)"
  },
  "colors.red.600": {
    "value": "rgb(250 124 114)",
    "variable": "var(--🐼-colors-red-600)"
  },
  "colors.red.700": {
    "value": "rgb(248 98 89)",
    "variable": "var(--🐼-colors-red-700)"
  },
  "colors.red.800": {
    "value": "rgb(239 71 64)",
    "variable": "var(--🐼-colors-red-800)"
  },
  "colors.red.900": {
    "value": "rgb(220 38 38)",
    "variable": "var(--🐼-colors-red-900)"
  },
  "colors.red.1000": {
    "value": "rgb(185 28 28)",
    "variable": "var(--🐼-colors-red-1000)"
  },
  "colors.red.1100": {
    "value": "rgb(156 27 27)",
    "variable": "var(--🐼-colors-red-1100)"
  },
  "colors.red.1200": {
    "value": "rgb(133 30 30)",
    "variable": "var(--🐼-colors-red-1200)"
  },
  "colors.red.1300": {
    "value": "rgb(114 34 34)",
    "variable": "var(--🐼-colors-red-1300)"
  },
  "colors.red.1400": {
    "value": "rgb(92 30 30)",
    "variable": "var(--🐼-colors-red-1400)"
  },
  "colors.red.1500": {
    "value": "rgb(69 26 26)",
    "variable": "var(--🐼-colors-red-1500)"
  },
  "colors.red.50A": {
    "value": "rgb(238 72 38 / 0.06)",
    "variable": "var(--🐼-colors-red-50-a)"
  },
  "colors.red.100A": {
    "value": "rgb(247 40 17 / 0.13)",
    "variable": "var(--🐼-colors-red-100-a)"
  },
  "colors.red.200A": {
    "value": "rgb(250 31 3 / 0.21)",
    "variable": "var(--🐼-colors-red-200-a)"
  },
  "colors.red.300A": {
    "value": "rgb(252 27 3 / 0.29)",
    "variable": "var(--🐼-colors-red-300-a)"
  },
  "colors.red.400A": {
    "value": "rgb(252 28 4 / 0.37)",
    "variable": "var(--🐼-colors-red-400-a)"
  },
  "colors.red.1200A": {
    "value": "rgb(252 50 49 / 0.51)",
    "variable": "var(--🐼-colors-red-1200-a)"
  },
  "colors.red.1300A": {
    "value": "rgb(253 67 66 / 0.43)",
    "variable": "var(--🐼-colors-red-1300-a)"
  },
  "colors.red.1400A": {
    "value": "rgb(253 71 69 / 0.34)",
    "variable": "var(--🐼-colors-red-1400-a)"
  },
  "colors.red.1500A": {
    "value": "rgb(249 77 74 / 0.25)",
    "variable": "var(--🐼-colors-red-1500-a)"
  },
  "colors.teal.50": {
    "value": "rgb(242 251 249)",
    "variable": "var(--🐼-colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "rgb(209 245 235)",
    "variable": "var(--🐼-colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "rgb(171 237 220)",
    "variable": "var(--🐼-colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "rgb(131 226 204)",
    "variable": "var(--🐼-colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "rgb(102 212 189)",
    "variable": "var(--🐼-colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "rgb(81 202 179)",
    "variable": "var(--🐼-colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "rgb(68 193 171)",
    "variable": "var(--🐼-colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "rgb(55 183 161)",
    "variable": "var(--🐼-colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "rgb(43 163 145)",
    "variable": "var(--🐼-colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "rgb(33 135 120)",
    "variable": "var(--🐼-colors-teal-900)"
  },
  "colors.teal.1000": {
    "value": "rgb(29 107 97)",
    "variable": "var(--🐼-colors-teal-1000)"
  },
  "colors.teal.1100": {
    "value": "rgb(28 86 78)",
    "variable": "var(--🐼-colors-teal-1100)"
  },
  "colors.teal.1200": {
    "value": "rgb(27 70 65)",
    "variable": "var(--🐼-colors-teal-1200)"
  },
  "colors.teal.1300": {
    "value": "rgb(25 59 56)",
    "variable": "var(--🐼-colors-teal-1300)"
  },
  "colors.teal.1400": {
    "value": "rgb(22 55 53)",
    "variable": "var(--🐼-colors-teal-1400)"
  },
  "colors.teal.1500": {
    "value": "rgb(21 50 49)",
    "variable": "var(--🐼-colors-teal-1500)"
  },
  "colors.teal.50A": {
    "value": "rgb(38 188 155 / 0.06)",
    "variable": "var(--🐼-colors-teal-50-a)"
  },
  "colors.teal.100A": {
    "value": "rgb(13 202 150 / 0.19)",
    "variable": "var(--🐼-colors-teal-100-a)"
  },
  "colors.teal.200A": {
    "value": "rgb(0 200 149 / 0.33)",
    "variable": "var(--🐼-colors-teal-200-a)"
  },
  "colors.teal.300A": {
    "value": "rgb(2 196 151 / 0.49)",
    "variable": "var(--🐼-colors-teal-300-a)"
  },
  "colors.teal.400A": {
    "value": "rgb(0 183 145 / 0.6)",
    "variable": "var(--🐼-colors-teal-400-a)"
  },
  "colors.teal.1200A": {
    "value": "rgb(81 253 230 / 0.25)",
    "variable": "var(--🐼-colors-teal-1200-a)"
  },
  "colors.teal.1300A": {
    "value": "rgb(85 247 229 / 0.21)",
    "variable": "var(--🐼-colors-teal-1300-a)"
  },
  "colors.teal.1400A": {
    "value": "rgb(77 251 236 / 0.19)",
    "variable": "var(--🐼-colors-teal-1400-a)"
  },
  "colors.teal.1500A": {
    "value": "rgb(80 250 239 / 0.17)",
    "variable": "var(--🐼-colors-teal-1500-a)"
  },
  "colors.violet.50": {
    "value": "rgb(241 240 255)",
    "variable": "var(--🐼-colors-violet-50)"
  },
  "colors.violet.100": {
    "value": "rgb(232 229 255)",
    "variable": "var(--🐼-colors-violet-100)"
  },
  "colors.violet.200": {
    "value": "rgb(220 216 255)",
    "variable": "var(--🐼-colors-violet-200)"
  },
  "colors.violet.300": {
    "value": "rgb(203 196 255)",
    "variable": "var(--🐼-colors-violet-300)"
  },
  "colors.violet.400": {
    "value": "rgb(189 178 255)",
    "variable": "var(--🐼-colors-violet-400)"
  },
  "colors.violet.500": {
    "value": "rgb(167 152 255)",
    "variable": "var(--🐼-colors-violet-500)"
  },
  "colors.violet.600": {
    "value": "rgb(150 128 255)",
    "variable": "var(--🐼-colors-violet-600)"
  },
  "colors.violet.700": {
    "value": "rgb(136 103 255)",
    "variable": "var(--🐼-colors-violet-700)"
  },
  "colors.violet.800": {
    "value": "rgb(127 77 255)",
    "variable": "var(--🐼-colors-violet-800)"
  },
  "colors.violet.900": {
    "value": "rgb(115 41 255)",
    "variable": "var(--🐼-colors-violet-900)"
  },
  "colors.violet.1000": {
    "value": "rgb(102 16 242)",
    "variable": "var(--🐼-colors-violet-1000)"
  },
  "colors.violet.1100": {
    "value": "rgb(91 12 210)",
    "variable": "var(--🐼-colors-violet-1100)"
  },
  "colors.violet.1200": {
    "value": "rgb(79 12 173)",
    "variable": "var(--🐼-colors-violet-1200)"
  },
  "colors.violet.1300": {
    "value": "rgb(69 13 148)",
    "variable": "var(--🐼-colors-violet-1300)"
  },
  "colors.violet.1400": {
    "value": "rgb(63 24 124)",
    "variable": "var(--🐼-colors-violet-1400)"
  },
  "colors.violet.1500": {
    "value": "rgb(51 28 93)",
    "variable": "var(--🐼-colors-violet-1500)"
  },
  "colors.violet.50A": {
    "value": "rgb(22 5 255 / 0.06)",
    "variable": "var(--🐼-colors-violet-50-a)"
  },
  "colors.violet.100A": {
    "value": "rgb(46 19 255 / 0.11)",
    "variable": "var(--🐼-colors-violet-100-a)"
  },
  "colors.violet.200A": {
    "value": "rgb(36 11 255 / 0.16)",
    "variable": "var(--🐼-colors-violet-200-a)"
  },
  "colors.violet.300A": {
    "value": "rgb(38 9 255 / 0.24)",
    "variable": "var(--🐼-colors-violet-300-a)"
  },
  "colors.violet.400A": {
    "value": "rgb(42 7 255 / 0.31)",
    "variable": "var(--🐼-colors-violet-400-a)"
  },
  "colors.violet.1200A": {
    "value": "rgb(113 13 253 / 0.67)",
    "variable": "var(--🐼-colors-violet-1200-a)"
  },
  "colors.violet.1300A": {
    "value": "rgb(114 16 252 / 0.57)",
    "variable": "var(--🐼-colors-violet-1300-a)"
  },
  "colors.violet.1400A": {
    "value": "rgb(124 41 253 / 0.47)",
    "variable": "var(--🐼-colors-violet-1400-a)"
  },
  "colors.violet.1500A": {
    "value": "rgb(133 65 254 / 0.34)",
    "variable": "var(--🐼-colors-violet-1500-a)"
  },
  "colors.yellow.50": {
    "value": "rgb(254 252 226)",
    "variable": "var(--🐼-colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "rgb(251 246 167)",
    "variable": "var(--🐼-colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "rgb(251 242 136)",
    "variable": "var(--🐼-colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "rgb(253 239 99)",
    "variable": "var(--🐼-colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "rgb(253 230 73)",
    "variable": "var(--🐼-colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "rgb(252 222 50)",
    "variable": "var(--🐼-colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "rgb(250 214 31)",
    "variable": "var(--🐼-colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "rgb(246 200 17)",
    "variable": "var(--🐼-colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "rgb(234 181 8)",
    "variable": "var(--🐼-colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "rgb(210 153 4)",
    "variable": "var(--🐼-colors-yellow-900)"
  },
  "colors.yellow.1000": {
    "value": "rgb(166 114 7)",
    "variable": "var(--🐼-colors-yellow-1000)"
  },
  "colors.yellow.1100": {
    "value": "rgb(138 92 14)",
    "variable": "var(--🐼-colors-yellow-1100)"
  },
  "colors.yellow.1200": {
    "value": "rgb(113 72 19)",
    "variable": "var(--🐼-colors-yellow-1200)"
  },
  "colors.yellow.1300": {
    "value": "rgb(92 57 20)",
    "variable": "var(--🐼-colors-yellow-1300)"
  },
  "colors.yellow.1400": {
    "value": "rgb(72 45 20)",
    "variable": "var(--🐼-colors-yellow-1400)"
  },
  "colors.yellow.1500": {
    "value": "rgb(59 36 18)",
    "variable": "var(--🐼-colors-yellow-1500)"
  },
  "colors.yellow.50A": {
    "value": "rgb(247 230 13 / 0.12)",
    "variable": "var(--🐼-colors-yellow-50-a)"
  },
  "colors.yellow.100A": {
    "value": "rgb(244 229 4 / 0.35)",
    "variable": "var(--🐼-colors-yellow-100-a)"
  },
  "colors.yellow.200A": {
    "value": "rgb(246 227 2 / 0.47)",
    "variable": "var(--🐼-colors-yellow-200-a)"
  },
  "colors.yellow.300A": {
    "value": "rgb(252 229 3 / 0.62)",
    "variable": "var(--🐼-colors-yellow-300-a)"
  },
  "colors.yellow.400A": {
    "value": "rgb(252 220 2 / 0.72)",
    "variable": "var(--🐼-colors-yellow-400-a)"
  },
  "colors.yellow.1200A": {
    "value": "rgb(249 138 46 / 0.42)",
    "variable": "var(--🐼-colors-yellow-1200-a)"
  },
  "colors.yellow.1300A": {
    "value": "rgb(253 150 39 / 0.34)",
    "variable": "var(--🐼-colors-yellow-1300-a)"
  },
  "colors.yellow.1400A": {
    "value": "rgb(251 147 48 / 0.28)",
    "variable": "var(--🐼-colors-yellow-1400-a)"
  },
  "colors.yellow.1500A": {
    "value": "rgb(247 138 48 / 0.21)",
    "variable": "var(--🐼-colors-yellow-1500-a)"
  },
  "colors.black": {
    "value": "rgb(9 9 10)",
    "variable": "var(--🐼-colors-black)"
  },
  "colors.white": {
    "value": "rgb(255 255 255)",
    "variable": "var(--🐼-colors-white)"
  },
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--🐼-colors-transparent)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--🐼-sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--🐼-sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--🐼-sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--🐼-sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--🐼-sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--🐼-sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--🐼-sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--🐼-sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--🐼-sizes-8)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--🐼-sizes-10)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--🐼-sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--🐼-sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--🐼-sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--🐼-sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--🐼-sizes-24)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--🐼-sizes-32)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--🐼-sizes-40)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--🐼-sizes-48)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--🐼-sizes-56)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--🐼-sizes-64)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--🐼-sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--🐼-sizes-96)"
  },
  "sizes.120": {
    "value": "30rem",
    "variable": "var(--🐼-sizes-120)"
  },
  "sizes.140": {
    "value": "35rem",
    "variable": "var(--🐼-sizes-140)"
  },
  "sizes.160": {
    "value": "40rem",
    "variable": "var(--🐼-sizes-160)"
  },
  "sizes.180": {
    "value": "45rem",
    "variable": "var(--🐼-sizes-180)"
  },
  "sizes.px": {
    "value": "0.0625rem",
    "variable": "var(--🐼-sizes-px)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--🐼-sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--🐼-sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--🐼-sizes-2\\.5)"
  },
  "sizes.breakpoint-xs": {
    "value": "320px",
    "variable": "var(--🐼-sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "480px",
    "variable": "var(--🐼-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--🐼-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--🐼-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1600px",
    "variable": "var(--🐼-sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1920px",
    "variable": "var(--🐼-sizes-breakpoint-2xl)"
  },
  "zIndex.0": {
    "value": "0",
    "variable": "var(--🐼-z-index-0)"
  },
  "zIndex.10": {
    "value": "10",
    "variable": "var(--🐼-z-index-10)"
  },
  "zIndex.20": {
    "value": "20",
    "variable": "var(--🐼-z-index-20)"
  },
  "zIndex.30": {
    "value": "30",
    "variable": "var(--🐼-z-index-30)"
  },
  "zIndex.40": {
    "value": "40",
    "variable": "var(--🐼-z-index-40)"
  },
  "breakpoints.xs": {
    "value": "320px",
    "variable": "var(--🐼-breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "480px",
    "variable": "var(--🐼-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--🐼-breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--🐼-breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1600px",
    "variable": "var(--🐼-breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "1920px",
    "variable": "var(--🐼-breakpoints-2xl)"
  },
  "colors.util.amber.1": {
    "value": "var(--🐼-colors-util-amber-1)",
    "variable": "var(--🐼-colors-util-amber-1)"
  },
  "colors.util.amber.2": {
    "value": "var(--🐼-colors-util-amber-2)",
    "variable": "var(--🐼-colors-util-amber-2)"
  },
  "colors.util.amber.3": {
    "value": "var(--🐼-colors-util-amber-3)",
    "variable": "var(--🐼-colors-util-amber-3)"
  },
  "colors.util.amber.4": {
    "value": "var(--🐼-colors-util-amber-4)",
    "variable": "var(--🐼-colors-util-amber-4)"
  },
  "colors.util.amber.5": {
    "value": "var(--🐼-colors-util-amber-5)",
    "variable": "var(--🐼-colors-util-amber-5)"
  },
  "colors.util.amber.6": {
    "value": "var(--🐼-colors-util-amber-6)",
    "variable": "var(--🐼-colors-util-amber-6)"
  },
  "colors.util.amber.7": {
    "value": "var(--🐼-colors-util-amber-7)",
    "variable": "var(--🐼-colors-util-amber-7)"
  },
  "colors.util.amber.8": {
    "value": "var(--🐼-colors-util-amber-8)",
    "variable": "var(--🐼-colors-util-amber-8)"
  },
  "colors.util.amber.1A": {
    "value": "var(--🐼-colors-util-amber-1-a)",
    "variable": "var(--🐼-colors-util-amber-1-a)"
  },
  "colors.util.amber.2A": {
    "value": "var(--🐼-colors-util-amber-2-a)",
    "variable": "var(--🐼-colors-util-amber-2-a)"
  },
  "colors.util.amber.3A": {
    "value": "var(--🐼-colors-util-amber-3-a)",
    "variable": "var(--🐼-colors-util-amber-3-a)"
  },
  "colors.util.amber.4A": {
    "value": "var(--🐼-colors-util-amber-4-a)",
    "variable": "var(--🐼-colors-util-amber-4-a)"
  },
  "colors.util.blue.1": {
    "value": "var(--🐼-colors-util-blue-1)",
    "variable": "var(--🐼-colors-util-blue-1)"
  },
  "colors.util.blue.2": {
    "value": "var(--🐼-colors-util-blue-2)",
    "variable": "var(--🐼-colors-util-blue-2)"
  },
  "colors.util.blue.3": {
    "value": "var(--🐼-colors-util-blue-3)",
    "variable": "var(--🐼-colors-util-blue-3)"
  },
  "colors.util.blue.4": {
    "value": "var(--🐼-colors-util-blue-4)",
    "variable": "var(--🐼-colors-util-blue-4)"
  },
  "colors.util.blue.5": {
    "value": "var(--🐼-colors-util-blue-5)",
    "variable": "var(--🐼-colors-util-blue-5)"
  },
  "colors.util.blue.6": {
    "value": "var(--🐼-colors-util-blue-6)",
    "variable": "var(--🐼-colors-util-blue-6)"
  },
  "colors.util.blue.7": {
    "value": "var(--🐼-colors-util-blue-7)",
    "variable": "var(--🐼-colors-util-blue-7)"
  },
  "colors.util.blue.8": {
    "value": "var(--🐼-colors-util-blue-8)",
    "variable": "var(--🐼-colors-util-blue-8)"
  },
  "colors.util.blue.1A": {
    "value": "var(--🐼-colors-util-blue-1-a)",
    "variable": "var(--🐼-colors-util-blue-1-a)"
  },
  "colors.util.blue.2A": {
    "value": "var(--🐼-colors-util-blue-2-a)",
    "variable": "var(--🐼-colors-util-blue-2-a)"
  },
  "colors.util.blue.3A": {
    "value": "var(--🐼-colors-util-blue-3-a)",
    "variable": "var(--🐼-colors-util-blue-3-a)"
  },
  "colors.util.blue.4A": {
    "value": "var(--🐼-colors-util-blue-4-a)",
    "variable": "var(--🐼-colors-util-blue-4-a)"
  },
  "colors.util.cyan.1": {
    "value": "var(--🐼-colors-util-cyan-1)",
    "variable": "var(--🐼-colors-util-cyan-1)"
  },
  "colors.util.cyan.2": {
    "value": "var(--🐼-colors-util-cyan-2)",
    "variable": "var(--🐼-colors-util-cyan-2)"
  },
  "colors.util.cyan.3": {
    "value": "var(--🐼-colors-util-cyan-3)",
    "variable": "var(--🐼-colors-util-cyan-3)"
  },
  "colors.util.cyan.4": {
    "value": "var(--🐼-colors-util-cyan-4)",
    "variable": "var(--🐼-colors-util-cyan-4)"
  },
  "colors.util.cyan.5": {
    "value": "var(--🐼-colors-util-cyan-5)",
    "variable": "var(--🐼-colors-util-cyan-5)"
  },
  "colors.util.cyan.6": {
    "value": "var(--🐼-colors-util-cyan-6)",
    "variable": "var(--🐼-colors-util-cyan-6)"
  },
  "colors.util.cyan.7": {
    "value": "var(--🐼-colors-util-cyan-7)",
    "variable": "var(--🐼-colors-util-cyan-7)"
  },
  "colors.util.cyan.8": {
    "value": "var(--🐼-colors-util-cyan-8)",
    "variable": "var(--🐼-colors-util-cyan-8)"
  },
  "colors.util.cyan.1A": {
    "value": "var(--🐼-colors-util-cyan-1-a)",
    "variable": "var(--🐼-colors-util-cyan-1-a)"
  },
  "colors.util.cyan.2A": {
    "value": "var(--🐼-colors-util-cyan-2-a)",
    "variable": "var(--🐼-colors-util-cyan-2-a)"
  },
  "colors.util.cyan.3A": {
    "value": "var(--🐼-colors-util-cyan-3-a)",
    "variable": "var(--🐼-colors-util-cyan-3-a)"
  },
  "colors.util.cyan.4A": {
    "value": "var(--🐼-colors-util-cyan-4-a)",
    "variable": "var(--🐼-colors-util-cyan-4-a)"
  },
  "colors.util.emerald.1": {
    "value": "var(--🐼-colors-util-emerald-1)",
    "variable": "var(--🐼-colors-util-emerald-1)"
  },
  "colors.util.emerald.2": {
    "value": "var(--🐼-colors-util-emerald-2)",
    "variable": "var(--🐼-colors-util-emerald-2)"
  },
  "colors.util.emerald.3": {
    "value": "var(--🐼-colors-util-emerald-3)",
    "variable": "var(--🐼-colors-util-emerald-3)"
  },
  "colors.util.emerald.4": {
    "value": "var(--🐼-colors-util-emerald-4)",
    "variable": "var(--🐼-colors-util-emerald-4)"
  },
  "colors.util.emerald.5": {
    "value": "var(--🐼-colors-util-emerald-5)",
    "variable": "var(--🐼-colors-util-emerald-5)"
  },
  "colors.util.emerald.6": {
    "value": "var(--🐼-colors-util-emerald-6)",
    "variable": "var(--🐼-colors-util-emerald-6)"
  },
  "colors.util.emerald.7": {
    "value": "var(--🐼-colors-util-emerald-7)",
    "variable": "var(--🐼-colors-util-emerald-7)"
  },
  "colors.util.emerald.8": {
    "value": "var(--🐼-colors-util-emerald-8)",
    "variable": "var(--🐼-colors-util-emerald-8)"
  },
  "colors.util.emerald.1A": {
    "value": "var(--🐼-colors-util-emerald-1-a)",
    "variable": "var(--🐼-colors-util-emerald-1-a)"
  },
  "colors.util.emerald.2A": {
    "value": "var(--🐼-colors-util-emerald-2-a)",
    "variable": "var(--🐼-colors-util-emerald-2-a)"
  },
  "colors.util.emerald.3A": {
    "value": "var(--🐼-colors-util-emerald-3-a)",
    "variable": "var(--🐼-colors-util-emerald-3-a)"
  },
  "colors.util.emerald.4A": {
    "value": "var(--🐼-colors-util-emerald-4-a)",
    "variable": "var(--🐼-colors-util-emerald-4-a)"
  },
  "colors.util.fuchsia.1": {
    "value": "var(--🐼-colors-util-fuchsia-1)",
    "variable": "var(--🐼-colors-util-fuchsia-1)"
  },
  "colors.util.fuchsia.2": {
    "value": "var(--🐼-colors-util-fuchsia-2)",
    "variable": "var(--🐼-colors-util-fuchsia-2)"
  },
  "colors.util.fuchsia.3": {
    "value": "var(--🐼-colors-util-fuchsia-3)",
    "variable": "var(--🐼-colors-util-fuchsia-3)"
  },
  "colors.util.fuchsia.4": {
    "value": "var(--🐼-colors-util-fuchsia-4)",
    "variable": "var(--🐼-colors-util-fuchsia-4)"
  },
  "colors.util.fuchsia.5": {
    "value": "var(--🐼-colors-util-fuchsia-5)",
    "variable": "var(--🐼-colors-util-fuchsia-5)"
  },
  "colors.util.fuchsia.6": {
    "value": "var(--🐼-colors-util-fuchsia-6)",
    "variable": "var(--🐼-colors-util-fuchsia-6)"
  },
  "colors.util.fuchsia.7": {
    "value": "var(--🐼-colors-util-fuchsia-7)",
    "variable": "var(--🐼-colors-util-fuchsia-7)"
  },
  "colors.util.fuchsia.8": {
    "value": "var(--🐼-colors-util-fuchsia-8)",
    "variable": "var(--🐼-colors-util-fuchsia-8)"
  },
  "colors.util.fuchsia.1A": {
    "value": "var(--🐼-colors-util-fuchsia-1-a)",
    "variable": "var(--🐼-colors-util-fuchsia-1-a)"
  },
  "colors.util.fuchsia.2A": {
    "value": "var(--🐼-colors-util-fuchsia-2-a)",
    "variable": "var(--🐼-colors-util-fuchsia-2-a)"
  },
  "colors.util.fuchsia.3A": {
    "value": "var(--🐼-colors-util-fuchsia-3-a)",
    "variable": "var(--🐼-colors-util-fuchsia-3-a)"
  },
  "colors.util.fuchsia.4A": {
    "value": "var(--🐼-colors-util-fuchsia-4-a)",
    "variable": "var(--🐼-colors-util-fuchsia-4-a)"
  },
  "colors.util.green.1": {
    "value": "var(--🐼-colors-util-green-1)",
    "variable": "var(--🐼-colors-util-green-1)"
  },
  "colors.util.green.2": {
    "value": "var(--🐼-colors-util-green-2)",
    "variable": "var(--🐼-colors-util-green-2)"
  },
  "colors.util.green.3": {
    "value": "var(--🐼-colors-util-green-3)",
    "variable": "var(--🐼-colors-util-green-3)"
  },
  "colors.util.green.4": {
    "value": "var(--🐼-colors-util-green-4)",
    "variable": "var(--🐼-colors-util-green-4)"
  },
  "colors.util.green.5": {
    "value": "var(--🐼-colors-util-green-5)",
    "variable": "var(--🐼-colors-util-green-5)"
  },
  "colors.util.green.6": {
    "value": "var(--🐼-colors-util-green-6)",
    "variable": "var(--🐼-colors-util-green-6)"
  },
  "colors.util.green.7": {
    "value": "var(--🐼-colors-util-green-7)",
    "variable": "var(--🐼-colors-util-green-7)"
  },
  "colors.util.green.8": {
    "value": "var(--🐼-colors-util-green-8)",
    "variable": "var(--🐼-colors-util-green-8)"
  },
  "colors.util.green.1A": {
    "value": "var(--🐼-colors-util-green-1-a)",
    "variable": "var(--🐼-colors-util-green-1-a)"
  },
  "colors.util.green.2A": {
    "value": "var(--🐼-colors-util-green-2-a)",
    "variable": "var(--🐼-colors-util-green-2-a)"
  },
  "colors.util.green.3A": {
    "value": "var(--🐼-colors-util-green-3-a)",
    "variable": "var(--🐼-colors-util-green-3-a)"
  },
  "colors.util.green.4A": {
    "value": "var(--🐼-colors-util-green-4-a)",
    "variable": "var(--🐼-colors-util-green-4-a)"
  },
  "colors.util.grey.1": {
    "value": "var(--🐼-colors-util-grey-1)",
    "variable": "var(--🐼-colors-util-grey-1)"
  },
  "colors.util.grey.2": {
    "value": "var(--🐼-colors-util-grey-2)",
    "variable": "var(--🐼-colors-util-grey-2)"
  },
  "colors.util.grey.3": {
    "value": "var(--🐼-colors-util-grey-3)",
    "variable": "var(--🐼-colors-util-grey-3)"
  },
  "colors.util.grey.4": {
    "value": "var(--🐼-colors-util-grey-4)",
    "variable": "var(--🐼-colors-util-grey-4)"
  },
  "colors.util.grey.5": {
    "value": "var(--🐼-colors-util-grey-5)",
    "variable": "var(--🐼-colors-util-grey-5)"
  },
  "colors.util.grey.6": {
    "value": "var(--🐼-colors-util-grey-6)",
    "variable": "var(--🐼-colors-util-grey-6)"
  },
  "colors.util.grey.7": {
    "value": "var(--🐼-colors-util-grey-7)",
    "variable": "var(--🐼-colors-util-grey-7)"
  },
  "colors.util.grey.8": {
    "value": "var(--🐼-colors-util-grey-8)",
    "variable": "var(--🐼-colors-util-grey-8)"
  },
  "colors.util.grey.1A": {
    "value": "var(--🐼-colors-util-grey-1-a)",
    "variable": "var(--🐼-colors-util-grey-1-a)"
  },
  "colors.util.grey.2A": {
    "value": "var(--🐼-colors-util-grey-2-a)",
    "variable": "var(--🐼-colors-util-grey-2-a)"
  },
  "colors.util.grey.3A": {
    "value": "var(--🐼-colors-util-grey-3-a)",
    "variable": "var(--🐼-colors-util-grey-3-a)"
  },
  "colors.util.grey.4A": {
    "value": "var(--🐼-colors-util-grey-4-a)",
    "variable": "var(--🐼-colors-util-grey-4-a)"
  },
  "colors.util.indigo.1": {
    "value": "var(--🐼-colors-util-indigo-1)",
    "variable": "var(--🐼-colors-util-indigo-1)"
  },
  "colors.util.indigo.2": {
    "value": "var(--🐼-colors-util-indigo-2)",
    "variable": "var(--🐼-colors-util-indigo-2)"
  },
  "colors.util.indigo.3": {
    "value": "var(--🐼-colors-util-indigo-3)",
    "variable": "var(--🐼-colors-util-indigo-3)"
  },
  "colors.util.indigo.4": {
    "value": "var(--🐼-colors-util-indigo-4)",
    "variable": "var(--🐼-colors-util-indigo-4)"
  },
  "colors.util.indigo.5": {
    "value": "var(--🐼-colors-util-indigo-5)",
    "variable": "var(--🐼-colors-util-indigo-5)"
  },
  "colors.util.indigo.6": {
    "value": "var(--🐼-colors-util-indigo-6)",
    "variable": "var(--🐼-colors-util-indigo-6)"
  },
  "colors.util.indigo.7": {
    "value": "var(--🐼-colors-util-indigo-7)",
    "variable": "var(--🐼-colors-util-indigo-7)"
  },
  "colors.util.indigo.8": {
    "value": "var(--🐼-colors-util-indigo-8)",
    "variable": "var(--🐼-colors-util-indigo-8)"
  },
  "colors.util.indigo.1A": {
    "value": "var(--🐼-colors-util-indigo-1-a)",
    "variable": "var(--🐼-colors-util-indigo-1-a)"
  },
  "colors.util.indigo.2A": {
    "value": "var(--🐼-colors-util-indigo-2-a)",
    "variable": "var(--🐼-colors-util-indigo-2-a)"
  },
  "colors.util.indigo.3A": {
    "value": "var(--🐼-colors-util-indigo-3-a)",
    "variable": "var(--🐼-colors-util-indigo-3-a)"
  },
  "colors.util.indigo.4A": {
    "value": "var(--🐼-colors-util-indigo-4-a)",
    "variable": "var(--🐼-colors-util-indigo-4-a)"
  },
  "colors.util.lime.1": {
    "value": "var(--🐼-colors-util-lime-1)",
    "variable": "var(--🐼-colors-util-lime-1)"
  },
  "colors.util.lime.2": {
    "value": "var(--🐼-colors-util-lime-2)",
    "variable": "var(--🐼-colors-util-lime-2)"
  },
  "colors.util.lime.3": {
    "value": "var(--🐼-colors-util-lime-3)",
    "variable": "var(--🐼-colors-util-lime-3)"
  },
  "colors.util.lime.4": {
    "value": "var(--🐼-colors-util-lime-4)",
    "variable": "var(--🐼-colors-util-lime-4)"
  },
  "colors.util.lime.5": {
    "value": "var(--🐼-colors-util-lime-5)",
    "variable": "var(--🐼-colors-util-lime-5)"
  },
  "colors.util.lime.6": {
    "value": "var(--🐼-colors-util-lime-6)",
    "variable": "var(--🐼-colors-util-lime-6)"
  },
  "colors.util.lime.7": {
    "value": "var(--🐼-colors-util-lime-7)",
    "variable": "var(--🐼-colors-util-lime-7)"
  },
  "colors.util.lime.8": {
    "value": "var(--🐼-colors-util-lime-8)",
    "variable": "var(--🐼-colors-util-lime-8)"
  },
  "colors.util.lime.1A": {
    "value": "var(--🐼-colors-util-lime-1-a)",
    "variable": "var(--🐼-colors-util-lime-1-a)"
  },
  "colors.util.lime.2A": {
    "value": "var(--🐼-colors-util-lime-2-a)",
    "variable": "var(--🐼-colors-util-lime-2-a)"
  },
  "colors.util.lime.3A": {
    "value": "var(--🐼-colors-util-lime-3-a)",
    "variable": "var(--🐼-colors-util-lime-3-a)"
  },
  "colors.util.lime.4A": {
    "value": "var(--🐼-colors-util-lime-4-a)",
    "variable": "var(--🐼-colors-util-lime-4-a)"
  },
  "colors.util.magenta.1": {
    "value": "var(--🐼-colors-util-magenta-1)",
    "variable": "var(--🐼-colors-util-magenta-1)"
  },
  "colors.util.magenta.2": {
    "value": "var(--🐼-colors-util-magenta-2)",
    "variable": "var(--🐼-colors-util-magenta-2)"
  },
  "colors.util.magenta.3": {
    "value": "var(--🐼-colors-util-magenta-3)",
    "variable": "var(--🐼-colors-util-magenta-3)"
  },
  "colors.util.magenta.4": {
    "value": "var(--🐼-colors-util-magenta-4)",
    "variable": "var(--🐼-colors-util-magenta-4)"
  },
  "colors.util.magenta.5": {
    "value": "var(--🐼-colors-util-magenta-5)",
    "variable": "var(--🐼-colors-util-magenta-5)"
  },
  "colors.util.magenta.6": {
    "value": "var(--🐼-colors-util-magenta-6)",
    "variable": "var(--🐼-colors-util-magenta-6)"
  },
  "colors.util.magenta.7": {
    "value": "var(--🐼-colors-util-magenta-7)",
    "variable": "var(--🐼-colors-util-magenta-7)"
  },
  "colors.util.magenta.8": {
    "value": "var(--🐼-colors-util-magenta-8)",
    "variable": "var(--🐼-colors-util-magenta-8)"
  },
  "colors.util.magenta.1A": {
    "value": "var(--🐼-colors-util-magenta-1-a)",
    "variable": "var(--🐼-colors-util-magenta-1-a)"
  },
  "colors.util.magenta.2A": {
    "value": "var(--🐼-colors-util-magenta-2-a)",
    "variable": "var(--🐼-colors-util-magenta-2-a)"
  },
  "colors.util.magenta.3A": {
    "value": "var(--🐼-colors-util-magenta-3-a)",
    "variable": "var(--🐼-colors-util-magenta-3-a)"
  },
  "colors.util.magenta.4A": {
    "value": "var(--🐼-colors-util-magenta-4-a)",
    "variable": "var(--🐼-colors-util-magenta-4-a)"
  },
  "colors.util.orange.1": {
    "value": "var(--🐼-colors-util-orange-1)",
    "variable": "var(--🐼-colors-util-orange-1)"
  },
  "colors.util.orange.2": {
    "value": "var(--🐼-colors-util-orange-2)",
    "variable": "var(--🐼-colors-util-orange-2)"
  },
  "colors.util.orange.3": {
    "value": "var(--🐼-colors-util-orange-3)",
    "variable": "var(--🐼-colors-util-orange-3)"
  },
  "colors.util.orange.4": {
    "value": "var(--🐼-colors-util-orange-4)",
    "variable": "var(--🐼-colors-util-orange-4)"
  },
  "colors.util.orange.5": {
    "value": "var(--🐼-colors-util-orange-5)",
    "variable": "var(--🐼-colors-util-orange-5)"
  },
  "colors.util.orange.6": {
    "value": "var(--🐼-colors-util-orange-6)",
    "variable": "var(--🐼-colors-util-orange-6)"
  },
  "colors.util.orange.7": {
    "value": "var(--🐼-colors-util-orange-7)",
    "variable": "var(--🐼-colors-util-orange-7)"
  },
  "colors.util.orange.8": {
    "value": "var(--🐼-colors-util-orange-8)",
    "variable": "var(--🐼-colors-util-orange-8)"
  },
  "colors.util.orange.1A": {
    "value": "var(--🐼-colors-util-orange-1-a)",
    "variable": "var(--🐼-colors-util-orange-1-a)"
  },
  "colors.util.orange.2A": {
    "value": "var(--🐼-colors-util-orange-2-a)",
    "variable": "var(--🐼-colors-util-orange-2-a)"
  },
  "colors.util.orange.3A": {
    "value": "var(--🐼-colors-util-orange-3-a)",
    "variable": "var(--🐼-colors-util-orange-3-a)"
  },
  "colors.util.orange.4A": {
    "value": "var(--🐼-colors-util-orange-4-a)",
    "variable": "var(--🐼-colors-util-orange-4-a)"
  },
  "colors.util.peach.1": {
    "value": "var(--🐼-colors-util-peach-1)",
    "variable": "var(--🐼-colors-util-peach-1)"
  },
  "colors.util.peach.2": {
    "value": "var(--🐼-colors-util-peach-2)",
    "variable": "var(--🐼-colors-util-peach-2)"
  },
  "colors.util.peach.3": {
    "value": "var(--🐼-colors-util-peach-3)",
    "variable": "var(--🐼-colors-util-peach-3)"
  },
  "colors.util.peach.4": {
    "value": "var(--🐼-colors-util-peach-4)",
    "variable": "var(--🐼-colors-util-peach-4)"
  },
  "colors.util.peach.5": {
    "value": "var(--🐼-colors-util-peach-5)",
    "variable": "var(--🐼-colors-util-peach-5)"
  },
  "colors.util.peach.6": {
    "value": "var(--🐼-colors-util-peach-6)",
    "variable": "var(--🐼-colors-util-peach-6)"
  },
  "colors.util.peach.7": {
    "value": "var(--🐼-colors-util-peach-7)",
    "variable": "var(--🐼-colors-util-peach-7)"
  },
  "colors.util.peach.8": {
    "value": "var(--🐼-colors-util-peach-8)",
    "variable": "var(--🐼-colors-util-peach-8)"
  },
  "colors.util.peach.1A": {
    "value": "var(--🐼-colors-util-peach-1-a)",
    "variable": "var(--🐼-colors-util-peach-1-a)"
  },
  "colors.util.peach.2A": {
    "value": "var(--🐼-colors-util-peach-2-a)",
    "variable": "var(--🐼-colors-util-peach-2-a)"
  },
  "colors.util.peach.3A": {
    "value": "var(--🐼-colors-util-peach-3-a)",
    "variable": "var(--🐼-colors-util-peach-3-a)"
  },
  "colors.util.peach.4A": {
    "value": "var(--🐼-colors-util-peach-4-a)",
    "variable": "var(--🐼-colors-util-peach-4-a)"
  },
  "colors.util.pink.1": {
    "value": "var(--🐼-colors-util-pink-1)",
    "variable": "var(--🐼-colors-util-pink-1)"
  },
  "colors.util.pink.2": {
    "value": "var(--🐼-colors-util-pink-2)",
    "variable": "var(--🐼-colors-util-pink-2)"
  },
  "colors.util.pink.3": {
    "value": "var(--🐼-colors-util-pink-3)",
    "variable": "var(--🐼-colors-util-pink-3)"
  },
  "colors.util.pink.4": {
    "value": "var(--🐼-colors-util-pink-4)",
    "variable": "var(--🐼-colors-util-pink-4)"
  },
  "colors.util.pink.5": {
    "value": "var(--🐼-colors-util-pink-5)",
    "variable": "var(--🐼-colors-util-pink-5)"
  },
  "colors.util.pink.6": {
    "value": "var(--🐼-colors-util-pink-6)",
    "variable": "var(--🐼-colors-util-pink-6)"
  },
  "colors.util.pink.7": {
    "value": "var(--🐼-colors-util-pink-7)",
    "variable": "var(--🐼-colors-util-pink-7)"
  },
  "colors.util.pink.8": {
    "value": "var(--🐼-colors-util-pink-8)",
    "variable": "var(--🐼-colors-util-pink-8)"
  },
  "colors.util.pink.1A": {
    "value": "var(--🐼-colors-util-pink-1-a)",
    "variable": "var(--🐼-colors-util-pink-1-a)"
  },
  "colors.util.pink.2A": {
    "value": "var(--🐼-colors-util-pink-2-a)",
    "variable": "var(--🐼-colors-util-pink-2-a)"
  },
  "colors.util.pink.3A": {
    "value": "var(--🐼-colors-util-pink-3-a)",
    "variable": "var(--🐼-colors-util-pink-3-a)"
  },
  "colors.util.pink.4A": {
    "value": "var(--🐼-colors-util-pink-4-a)",
    "variable": "var(--🐼-colors-util-pink-4-a)"
  },
  "colors.util.purple.1": {
    "value": "var(--🐼-colors-util-purple-1)",
    "variable": "var(--🐼-colors-util-purple-1)"
  },
  "colors.util.purple.2": {
    "value": "var(--🐼-colors-util-purple-2)",
    "variable": "var(--🐼-colors-util-purple-2)"
  },
  "colors.util.purple.3": {
    "value": "var(--🐼-colors-util-purple-3)",
    "variable": "var(--🐼-colors-util-purple-3)"
  },
  "colors.util.purple.4": {
    "value": "var(--🐼-colors-util-purple-4)",
    "variable": "var(--🐼-colors-util-purple-4)"
  },
  "colors.util.purple.5": {
    "value": "var(--🐼-colors-util-purple-5)",
    "variable": "var(--🐼-colors-util-purple-5)"
  },
  "colors.util.purple.6": {
    "value": "var(--🐼-colors-util-purple-6)",
    "variable": "var(--🐼-colors-util-purple-6)"
  },
  "colors.util.purple.7": {
    "value": "var(--🐼-colors-util-purple-7)",
    "variable": "var(--🐼-colors-util-purple-7)"
  },
  "colors.util.purple.8": {
    "value": "var(--🐼-colors-util-purple-8)",
    "variable": "var(--🐼-colors-util-purple-8)"
  },
  "colors.util.purple.1A": {
    "value": "var(--🐼-colors-util-purple-1-a)",
    "variable": "var(--🐼-colors-util-purple-1-a)"
  },
  "colors.util.purple.2A": {
    "value": "var(--🐼-colors-util-purple-2-a)",
    "variable": "var(--🐼-colors-util-purple-2-a)"
  },
  "colors.util.purple.3A": {
    "value": "var(--🐼-colors-util-purple-3-a)",
    "variable": "var(--🐼-colors-util-purple-3-a)"
  },
  "colors.util.purple.4A": {
    "value": "var(--🐼-colors-util-purple-4-a)",
    "variable": "var(--🐼-colors-util-purple-4-a)"
  },
  "colors.util.red.1": {
    "value": "var(--🐼-colors-util-red-1)",
    "variable": "var(--🐼-colors-util-red-1)"
  },
  "colors.util.red.2": {
    "value": "var(--🐼-colors-util-red-2)",
    "variable": "var(--🐼-colors-util-red-2)"
  },
  "colors.util.red.3": {
    "value": "var(--🐼-colors-util-red-3)",
    "variable": "var(--🐼-colors-util-red-3)"
  },
  "colors.util.red.4": {
    "value": "var(--🐼-colors-util-red-4)",
    "variable": "var(--🐼-colors-util-red-4)"
  },
  "colors.util.red.5": {
    "value": "var(--🐼-colors-util-red-5)",
    "variable": "var(--🐼-colors-util-red-5)"
  },
  "colors.util.red.6": {
    "value": "var(--🐼-colors-util-red-6)",
    "variable": "var(--🐼-colors-util-red-6)"
  },
  "colors.util.red.7": {
    "value": "var(--🐼-colors-util-red-7)",
    "variable": "var(--🐼-colors-util-red-7)"
  },
  "colors.util.red.8": {
    "value": "var(--🐼-colors-util-red-8)",
    "variable": "var(--🐼-colors-util-red-8)"
  },
  "colors.util.red.1A": {
    "value": "var(--🐼-colors-util-red-1-a)",
    "variable": "var(--🐼-colors-util-red-1-a)"
  },
  "colors.util.red.2A": {
    "value": "var(--🐼-colors-util-red-2-a)",
    "variable": "var(--🐼-colors-util-red-2-a)"
  },
  "colors.util.red.3A": {
    "value": "var(--🐼-colors-util-red-3-a)",
    "variable": "var(--🐼-colors-util-red-3-a)"
  },
  "colors.util.red.4A": {
    "value": "var(--🐼-colors-util-red-4-a)",
    "variable": "var(--🐼-colors-util-red-4-a)"
  },
  "colors.util.teal.1": {
    "value": "var(--🐼-colors-util-teal-1)",
    "variable": "var(--🐼-colors-util-teal-1)"
  },
  "colors.util.teal.2": {
    "value": "var(--🐼-colors-util-teal-2)",
    "variable": "var(--🐼-colors-util-teal-2)"
  },
  "colors.util.teal.3": {
    "value": "var(--🐼-colors-util-teal-3)",
    "variable": "var(--🐼-colors-util-teal-3)"
  },
  "colors.util.teal.4": {
    "value": "var(--🐼-colors-util-teal-4)",
    "variable": "var(--🐼-colors-util-teal-4)"
  },
  "colors.util.teal.5": {
    "value": "var(--🐼-colors-util-teal-5)",
    "variable": "var(--🐼-colors-util-teal-5)"
  },
  "colors.util.teal.6": {
    "value": "var(--🐼-colors-util-teal-6)",
    "variable": "var(--🐼-colors-util-teal-6)"
  },
  "colors.util.teal.7": {
    "value": "var(--🐼-colors-util-teal-7)",
    "variable": "var(--🐼-colors-util-teal-7)"
  },
  "colors.util.teal.8": {
    "value": "var(--🐼-colors-util-teal-8)",
    "variable": "var(--🐼-colors-util-teal-8)"
  },
  "colors.util.teal.1A": {
    "value": "var(--🐼-colors-util-teal-1-a)",
    "variable": "var(--🐼-colors-util-teal-1-a)"
  },
  "colors.util.teal.2A": {
    "value": "var(--🐼-colors-util-teal-2-a)",
    "variable": "var(--🐼-colors-util-teal-2-a)"
  },
  "colors.util.teal.3A": {
    "value": "var(--🐼-colors-util-teal-3-a)",
    "variable": "var(--🐼-colors-util-teal-3-a)"
  },
  "colors.util.teal.4A": {
    "value": "var(--🐼-colors-util-teal-4-a)",
    "variable": "var(--🐼-colors-util-teal-4-a)"
  },
  "colors.util.violet.1": {
    "value": "var(--🐼-colors-util-violet-1)",
    "variable": "var(--🐼-colors-util-violet-1)"
  },
  "colors.util.violet.2": {
    "value": "var(--🐼-colors-util-violet-2)",
    "variable": "var(--🐼-colors-util-violet-2)"
  },
  "colors.util.violet.3": {
    "value": "var(--🐼-colors-util-violet-3)",
    "variable": "var(--🐼-colors-util-violet-3)"
  },
  "colors.util.violet.4": {
    "value": "var(--🐼-colors-util-violet-4)",
    "variable": "var(--🐼-colors-util-violet-4)"
  },
  "colors.util.violet.5": {
    "value": "var(--🐼-colors-util-violet-5)",
    "variable": "var(--🐼-colors-util-violet-5)"
  },
  "colors.util.violet.6": {
    "value": "var(--🐼-colors-util-violet-6)",
    "variable": "var(--🐼-colors-util-violet-6)"
  },
  "colors.util.violet.7": {
    "value": "var(--🐼-colors-util-violet-7)",
    "variable": "var(--🐼-colors-util-violet-7)"
  },
  "colors.util.violet.8": {
    "value": "var(--🐼-colors-util-violet-8)",
    "variable": "var(--🐼-colors-util-violet-8)"
  },
  "colors.util.violet.1A": {
    "value": "var(--🐼-colors-util-violet-1-a)",
    "variable": "var(--🐼-colors-util-violet-1-a)"
  },
  "colors.util.violet.2A": {
    "value": "var(--🐼-colors-util-violet-2-a)",
    "variable": "var(--🐼-colors-util-violet-2-a)"
  },
  "colors.util.violet.3A": {
    "value": "var(--🐼-colors-util-violet-3-a)",
    "variable": "var(--🐼-colors-util-violet-3-a)"
  },
  "colors.util.violet.4A": {
    "value": "var(--🐼-colors-util-violet-4-a)",
    "variable": "var(--🐼-colors-util-violet-4-a)"
  },
  "colors.util.yellow.1": {
    "value": "var(--🐼-colors-util-yellow-1)",
    "variable": "var(--🐼-colors-util-yellow-1)"
  },
  "colors.util.yellow.2": {
    "value": "var(--🐼-colors-util-yellow-2)",
    "variable": "var(--🐼-colors-util-yellow-2)"
  },
  "colors.util.yellow.3": {
    "value": "var(--🐼-colors-util-yellow-3)",
    "variable": "var(--🐼-colors-util-yellow-3)"
  },
  "colors.util.yellow.4": {
    "value": "var(--🐼-colors-util-yellow-4)",
    "variable": "var(--🐼-colors-util-yellow-4)"
  },
  "colors.util.yellow.5": {
    "value": "var(--🐼-colors-util-yellow-5)",
    "variable": "var(--🐼-colors-util-yellow-5)"
  },
  "colors.util.yellow.6": {
    "value": "var(--🐼-colors-util-yellow-6)",
    "variable": "var(--🐼-colors-util-yellow-6)"
  },
  "colors.util.yellow.7": {
    "value": "var(--🐼-colors-util-yellow-7)",
    "variable": "var(--🐼-colors-util-yellow-7)"
  },
  "colors.util.yellow.8": {
    "value": "var(--🐼-colors-util-yellow-8)",
    "variable": "var(--🐼-colors-util-yellow-8)"
  },
  "colors.util.yellow.1A": {
    "value": "var(--🐼-colors-util-yellow-1-a)",
    "variable": "var(--🐼-colors-util-yellow-1-a)"
  },
  "colors.util.yellow.2A": {
    "value": "var(--🐼-colors-util-yellow-2-a)",
    "variable": "var(--🐼-colors-util-yellow-2-a)"
  },
  "colors.util.yellow.3A": {
    "value": "var(--🐼-colors-util-yellow-3-a)",
    "variable": "var(--🐼-colors-util-yellow-3-a)"
  },
  "colors.util.yellow.4A": {
    "value": "var(--🐼-colors-util-yellow-4-a)",
    "variable": "var(--🐼-colors-util-yellow-4-a)"
  },
  "spacing.-1": {
    "value": "calc(var(--🐼-spacing-1) * -1)",
    "variable": "var(--🐼-spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--🐼-spacing-2) * -1)",
    "variable": "var(--🐼-spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--🐼-spacing-3) * -1)",
    "variable": "var(--🐼-spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--🐼-spacing-4) * -1)",
    "variable": "var(--🐼-spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--🐼-spacing-5) * -1)",
    "variable": "var(--🐼-spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--🐼-spacing-6) * -1)",
    "variable": "var(--🐼-spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--🐼-spacing-7) * -1)",
    "variable": "var(--🐼-spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--🐼-spacing-8) * -1)",
    "variable": "var(--🐼-spacing-8)"
  },
  "spacing.-10": {
    "value": "calc(var(--🐼-spacing-10) * -1)",
    "variable": "var(--🐼-spacing-10)"
  },
  "spacing.-12": {
    "value": "calc(var(--🐼-spacing-12) * -1)",
    "variable": "var(--🐼-spacing-12)"
  },
  "spacing.-16": {
    "value": "calc(var(--🐼-spacing-16) * -1)",
    "variable": "var(--🐼-spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--🐼-spacing-20) * -1)",
    "variable": "var(--🐼-spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--🐼-spacing-24) * -1)",
    "variable": "var(--🐼-spacing-24)"
  },
  "spacing.-32": {
    "value": "calc(var(--🐼-spacing-32) * -1)",
    "variable": "var(--🐼-spacing-32)"
  },
  "spacing.-px": {
    "value": "calc(var(--🐼-spacing-px) * -1)",
    "variable": "var(--🐼-spacing-px)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--🐼-spacing-0\\.5) * -1)",
    "variable": "var(--🐼-spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--🐼-spacing-1\\.5) * -1)",
    "variable": "var(--🐼-spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--🐼-spacing-2\\.5) * -1)",
    "variable": "var(--🐼-spacing-2\\.5)"
  },
  "colors.base.sunken": {
    "value": "var(--🐼-colors-base-sunken)",
    "variable": "var(--🐼-colors-base-sunken)"
  },
  "colors.base.default": {
    "value": "var(--🐼-colors-base-default)",
    "variable": "var(--🐼-colors-base-default)"
  },
  "colors.base.raised": {
    "value": "var(--🐼-colors-base-raised)",
    "variable": "var(--🐼-colors-base-raised)"
  },
  "colors.base.overlay": {
    "value": "var(--🐼-colors-base-overlay)",
    "variable": "var(--🐼-colors-base-overlay)"
  },
  "colors.focus.accent.1": {
    "value": "var(--🐼-colors-focus-accent-1)",
    "variable": "var(--🐼-colors-focus-accent-1)"
  },
  "colors.focus.accent.2": {
    "value": "var(--🐼-colors-focus-accent-2)",
    "variable": "var(--🐼-colors-focus-accent-2)"
  },
  "colors.focus.critical.1": {
    "value": "var(--🐼-colors-focus-critical-1)",
    "variable": "var(--🐼-colors-focus-critical-1)"
  },
  "colors.focus.critical.2": {
    "value": "var(--🐼-colors-focus-critical-2)",
    "variable": "var(--🐼-colors-focus-critical-2)"
  },
  "colors.shadow.neutral.1": {
    "value": "var(--🐼-colors-shadow-neutral-1)",
    "variable": "var(--🐼-colors-shadow-neutral-1)"
  },
  "colors.shadow.neutral.2": {
    "value": "var(--🐼-colors-shadow-neutral-2)",
    "variable": "var(--🐼-colors-shadow-neutral-2)"
  },
  "colors.fill.neutral.primary": {
    "value": "var(--🐼-colors-fill-neutral-primary)",
    "variable": "var(--🐼-colors-fill-neutral-primary)"
  },
  "colors.fill.neutral.primary.hover": {
    "value": "var(--🐼-colors-fill-neutral-primary-hover)",
    "variable": "var(--🐼-colors-fill-neutral-primary-hover)"
  },
  "colors.fill.neutral.primary.selected": {
    "value": "var(--🐼-colors-fill-neutral-primary-selected)",
    "variable": "var(--🐼-colors-fill-neutral-primary-selected)"
  },
  "colors.fill.neutral.secondary": {
    "value": "var(--🐼-colors-fill-neutral-secondary)",
    "variable": "var(--🐼-colors-fill-neutral-secondary)"
  },
  "colors.fill.neutral.secondary.hover": {
    "value": "var(--🐼-colors-fill-neutral-secondary-hover)",
    "variable": "var(--🐼-colors-fill-neutral-secondary-hover)"
  },
  "colors.fill.neutral.secondary.selected": {
    "value": "var(--🐼-colors-fill-neutral-secondary-selected)",
    "variable": "var(--🐼-colors-fill-neutral-secondary-selected)"
  },
  "colors.fill.neutral.tertiary": {
    "value": "var(--🐼-colors-fill-neutral-tertiary)",
    "variable": "var(--🐼-colors-fill-neutral-tertiary)"
  },
  "colors.fill.neutral.tertiary.hover": {
    "value": "var(--🐼-colors-fill-neutral-tertiary-hover)",
    "variable": "var(--🐼-colors-fill-neutral-tertiary-hover)"
  },
  "colors.fill.neutral.tertiary.selected": {
    "value": "var(--🐼-colors-fill-neutral-tertiary-selected)",
    "variable": "var(--🐼-colors-fill-neutral-tertiary-selected)"
  },
  "colors.fill.accent.primary": {
    "value": "var(--🐼-colors-fill-accent-primary)",
    "variable": "var(--🐼-colors-fill-accent-primary)"
  },
  "colors.fill.accent.primary.hover": {
    "value": "var(--🐼-colors-fill-accent-primary-hover)",
    "variable": "var(--🐼-colors-fill-accent-primary-hover)"
  },
  "colors.fill.accent.primary.selected": {
    "value": "var(--🐼-colors-fill-accent-primary-selected)",
    "variable": "var(--🐼-colors-fill-accent-primary-selected)"
  },
  "colors.fill.accent.secondary": {
    "value": "var(--🐼-colors-fill-accent-secondary)",
    "variable": "var(--🐼-colors-fill-accent-secondary)"
  },
  "colors.fill.accent.secondary.hover": {
    "value": "var(--🐼-colors-fill-accent-secondary-hover)",
    "variable": "var(--🐼-colors-fill-accent-secondary-hover)"
  },
  "colors.fill.accent.secondary.selected": {
    "value": "var(--🐼-colors-fill-accent-secondary-selected)",
    "variable": "var(--🐼-colors-fill-accent-secondary-selected)"
  },
  "colors.fill.critical.primary": {
    "value": "var(--🐼-colors-fill-critical-primary)",
    "variable": "var(--🐼-colors-fill-critical-primary)"
  },
  "colors.fill.critical.primary.hover": {
    "value": "var(--🐼-colors-fill-critical-primary-hover)",
    "variable": "var(--🐼-colors-fill-critical-primary-hover)"
  },
  "colors.fill.critical.primary.selected": {
    "value": "var(--🐼-colors-fill-critical-primary-selected)",
    "variable": "var(--🐼-colors-fill-critical-primary-selected)"
  },
  "colors.fill.notice.primary": {
    "value": "var(--🐼-colors-fill-notice-primary)",
    "variable": "var(--🐼-colors-fill-notice-primary)"
  },
  "colors.fill.notice.primary.hover": {
    "value": "var(--🐼-colors-fill-notice-primary-hover)",
    "variable": "var(--🐼-colors-fill-notice-primary-hover)"
  },
  "colors.fill.notice.primary.selected": {
    "value": "var(--🐼-colors-fill-notice-primary-selected)",
    "variable": "var(--🐼-colors-fill-notice-primary-selected)"
  },
  "colors.fill.success.primary": {
    "value": "var(--🐼-colors-fill-success-primary)",
    "variable": "var(--🐼-colors-fill-success-primary)"
  },
  "colors.fill.success.primary.hover": {
    "value": "var(--🐼-colors-fill-success-primary-hover)",
    "variable": "var(--🐼-colors-fill-success-primary-hover)"
  },
  "colors.fill.success.primary.selected": {
    "value": "var(--🐼-colors-fill-success-primary-selected)",
    "variable": "var(--🐼-colors-fill-success-primary-selected)"
  },
  "colors.bg.neutral.hover": {
    "value": "var(--🐼-colors-bg-neutral-hover)",
    "variable": "var(--🐼-colors-bg-neutral-hover)"
  },
  "colors.bg.neutral.hover.alpha": {
    "value": "var(--🐼-colors-bg-neutral-hover-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-hover-alpha)"
  },
  "colors.bg.neutral.selected.alpha": {
    "value": "var(--🐼-colors-bg-neutral-selected-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-selected-alpha)"
  },
  "colors.bg.neutral.primary": {
    "value": "var(--🐼-colors-bg-neutral-primary)",
    "variable": "var(--🐼-colors-bg-neutral-primary)"
  },
  "colors.bg.neutral.primary.alpha": {
    "value": "var(--🐼-colors-bg-neutral-primary-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-primary-alpha)"
  },
  "colors.bg.neutral.primary.hover": {
    "value": "var(--🐼-colors-bg-neutral-primary-hover)",
    "variable": "var(--🐼-colors-bg-neutral-primary-hover)"
  },
  "colors.bg.neutral.primary.hover.alpha": {
    "value": "var(--🐼-colors-bg-neutral-primary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-primary-hover-alpha)"
  },
  "colors.bg.neutral.primary.selected": {
    "value": "var(--🐼-colors-bg-neutral-primary-selected)",
    "variable": "var(--🐼-colors-bg-neutral-primary-selected)"
  },
  "colors.bg.neutral.primary.selected.alpha": {
    "value": "var(--🐼-colors-bg-neutral-primary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-primary-selected-alpha)"
  },
  "colors.bg.neutral.secondary": {
    "value": "var(--🐼-colors-bg-neutral-secondary)",
    "variable": "var(--🐼-colors-bg-neutral-secondary)"
  },
  "colors.bg.neutral.secondary.alpha": {
    "value": "var(--🐼-colors-bg-neutral-secondary-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-secondary-alpha)"
  },
  "colors.bg.neutral.secondary.hover": {
    "value": "var(--🐼-colors-bg-neutral-secondary-hover)",
    "variable": "var(--🐼-colors-bg-neutral-secondary-hover)"
  },
  "colors.bg.neutral.secondary.hover.alpha": {
    "value": "var(--🐼-colors-bg-neutral-secondary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-secondary-hover-alpha)"
  },
  "colors.bg.neutral.secondary.selected": {
    "value": "var(--🐼-colors-bg-neutral-secondary-selected)",
    "variable": "var(--🐼-colors-bg-neutral-secondary-selected)"
  },
  "colors.bg.neutral.secondary.selected.alpha": {
    "value": "var(--🐼-colors-bg-neutral-secondary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-neutral-secondary-selected-alpha)"
  },
  "colors.bg.accent.hover": {
    "value": "var(--🐼-colors-bg-accent-hover)",
    "variable": "var(--🐼-colors-bg-accent-hover)"
  },
  "colors.bg.accent.hover.alpha": {
    "value": "var(--🐼-colors-bg-accent-hover-alpha)",
    "variable": "var(--🐼-colors-bg-accent-hover-alpha)"
  },
  "colors.bg.accent.selected.alpha": {
    "value": "var(--🐼-colors-bg-accent-selected-alpha)",
    "variable": "var(--🐼-colors-bg-accent-selected-alpha)"
  },
  "colors.bg.accent.primary": {
    "value": "var(--🐼-colors-bg-accent-primary)",
    "variable": "var(--🐼-colors-bg-accent-primary)"
  },
  "colors.bg.accent.primary.alpha": {
    "value": "var(--🐼-colors-bg-accent-primary-alpha)",
    "variable": "var(--🐼-colors-bg-accent-primary-alpha)"
  },
  "colors.bg.accent.primary.hover": {
    "value": "var(--🐼-colors-bg-accent-primary-hover)",
    "variable": "var(--🐼-colors-bg-accent-primary-hover)"
  },
  "colors.bg.accent.primary.hover.alpha": {
    "value": "var(--🐼-colors-bg-accent-primary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-accent-primary-hover-alpha)"
  },
  "colors.bg.accent.primary.selected": {
    "value": "var(--🐼-colors-bg-accent-primary-selected)",
    "variable": "var(--🐼-colors-bg-accent-primary-selected)"
  },
  "colors.bg.accent.primary.selected.alpha": {
    "value": "var(--🐼-colors-bg-accent-primary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-accent-primary-selected-alpha)"
  },
  "colors.bg.accent.secondary": {
    "value": "var(--🐼-colors-bg-accent-secondary)",
    "variable": "var(--🐼-colors-bg-accent-secondary)"
  },
  "colors.bg.accent.secondary.alpha": {
    "value": "var(--🐼-colors-bg-accent-secondary-alpha)",
    "variable": "var(--🐼-colors-bg-accent-secondary-alpha)"
  },
  "colors.bg.critical.hover.alpha": {
    "value": "var(--🐼-colors-bg-critical-hover-alpha)",
    "variable": "var(--🐼-colors-bg-critical-hover-alpha)"
  },
  "colors.bg.critical.selected.alpha": {
    "value": "var(--🐼-colors-bg-critical-selected-alpha)",
    "variable": "var(--🐼-colors-bg-critical-selected-alpha)"
  },
  "colors.bg.critical.primary": {
    "value": "var(--🐼-colors-bg-critical-primary)",
    "variable": "var(--🐼-colors-bg-critical-primary)"
  },
  "colors.bg.critical.primary.alpha": {
    "value": "var(--🐼-colors-bg-critical-primary-alpha)",
    "variable": "var(--🐼-colors-bg-critical-primary-alpha)"
  },
  "colors.bg.critical.primary.hover": {
    "value": "var(--🐼-colors-bg-critical-primary-hover)",
    "variable": "var(--🐼-colors-bg-critical-primary-hover)"
  },
  "colors.bg.critical.primary.hover.alpha": {
    "value": "var(--🐼-colors-bg-critical-primary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-critical-primary-hover-alpha)"
  },
  "colors.bg.critical.primary.selected": {
    "value": "var(--🐼-colors-bg-critical-primary-selected)",
    "variable": "var(--🐼-colors-bg-critical-primary-selected)"
  },
  "colors.bg.critical.primary.selected.alpha": {
    "value": "var(--🐼-colors-bg-critical-primary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-critical-primary-selected-alpha)"
  },
  "colors.bg.critical.secondary": {
    "value": "var(--🐼-colors-bg-critical-secondary)",
    "variable": "var(--🐼-colors-bg-critical-secondary)"
  },
  "colors.bg.critical.secondary.alpha": {
    "value": "var(--🐼-colors-bg-critical-secondary-alpha)",
    "variable": "var(--🐼-colors-bg-critical-secondary-alpha)"
  },
  "colors.bg.notice.hover.alpha": {
    "value": "var(--🐼-colors-bg-notice-hover-alpha)",
    "variable": "var(--🐼-colors-bg-notice-hover-alpha)"
  },
  "colors.bg.notice.selected.alpha": {
    "value": "var(--🐼-colors-bg-notice-selected-alpha)",
    "variable": "var(--🐼-colors-bg-notice-selected-alpha)"
  },
  "colors.bg.notice.primary": {
    "value": "var(--🐼-colors-bg-notice-primary)",
    "variable": "var(--🐼-colors-bg-notice-primary)"
  },
  "colors.bg.notice.primary.alpha": {
    "value": "var(--🐼-colors-bg-notice-primary-alpha)",
    "variable": "var(--🐼-colors-bg-notice-primary-alpha)"
  },
  "colors.bg.notice.primary.hover": {
    "value": "var(--🐼-colors-bg-notice-primary-hover)",
    "variable": "var(--🐼-colors-bg-notice-primary-hover)"
  },
  "colors.bg.notice.primary.hover.alpha": {
    "value": "var(--🐼-colors-bg-notice-primary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-notice-primary-hover-alpha)"
  },
  "colors.bg.notice.primary.selected": {
    "value": "var(--🐼-colors-bg-notice-primary-selected)",
    "variable": "var(--🐼-colors-bg-notice-primary-selected)"
  },
  "colors.bg.notice.primary.selected.alpha": {
    "value": "var(--🐼-colors-bg-notice-primary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-notice-primary-selected-alpha)"
  },
  "colors.bg.notice.secondary": {
    "value": "var(--🐼-colors-bg-notice-secondary)",
    "variable": "var(--🐼-colors-bg-notice-secondary)"
  },
  "colors.bg.notice.secondary.alpha": {
    "value": "var(--🐼-colors-bg-notice-secondary-alpha)",
    "variable": "var(--🐼-colors-bg-notice-secondary-alpha)"
  },
  "colors.bg.success.hover.alpha": {
    "value": "var(--🐼-colors-bg-success-hover-alpha)",
    "variable": "var(--🐼-colors-bg-success-hover-alpha)"
  },
  "colors.bg.success.selected.alpha": {
    "value": "var(--🐼-colors-bg-success-selected-alpha)",
    "variable": "var(--🐼-colors-bg-success-selected-alpha)"
  },
  "colors.bg.success.primary": {
    "value": "var(--🐼-colors-bg-success-primary)",
    "variable": "var(--🐼-colors-bg-success-primary)"
  },
  "colors.bg.success.primary.alpha": {
    "value": "var(--🐼-colors-bg-success-primary-alpha)",
    "variable": "var(--🐼-colors-bg-success-primary-alpha)"
  },
  "colors.bg.success.primary.hover": {
    "value": "var(--🐼-colors-bg-success-primary-hover)",
    "variable": "var(--🐼-colors-bg-success-primary-hover)"
  },
  "colors.bg.success.primary.hover.alpha": {
    "value": "var(--🐼-colors-bg-success-primary-hover-alpha)",
    "variable": "var(--🐼-colors-bg-success-primary-hover-alpha)"
  },
  "colors.bg.success.primary.selected": {
    "value": "var(--🐼-colors-bg-success-primary-selected)",
    "variable": "var(--🐼-colors-bg-success-primary-selected)"
  },
  "colors.bg.success.primary.selected.alpha": {
    "value": "var(--🐼-colors-bg-success-primary-selected-alpha)",
    "variable": "var(--🐼-colors-bg-success-primary-selected-alpha)"
  },
  "colors.bg.success.secondary": {
    "value": "var(--🐼-colors-bg-success-secondary)",
    "variable": "var(--🐼-colors-bg-success-secondary)"
  },
  "colors.bg.success.secondary.alpha": {
    "value": "var(--🐼-colors-bg-success-secondary-alpha)",
    "variable": "var(--🐼-colors-bg-success-secondary-alpha)"
  },
  "colors.text.neutral.primary": {
    "value": "var(--🐼-colors-text-neutral-primary)",
    "variable": "var(--🐼-colors-text-neutral-primary)"
  },
  "colors.text.neutral.primary.alpha": {
    "value": "var(--🐼-colors-text-neutral-primary-alpha)",
    "variable": "var(--🐼-colors-text-neutral-primary-alpha)"
  },
  "colors.text.neutral.primary.on.neutral": {
    "value": "var(--🐼-colors-text-neutral-primary-on-neutral)",
    "variable": "var(--🐼-colors-text-neutral-primary-on-neutral)"
  },
  "colors.text.neutral.primary.on.accent": {
    "value": "var(--🐼-colors-text-neutral-primary-on-accent)",
    "variable": "var(--🐼-colors-text-neutral-primary-on-accent)"
  },
  "colors.text.neutral.primary.on.success": {
    "value": "var(--🐼-colors-text-neutral-primary-on-success)",
    "variable": "var(--🐼-colors-text-neutral-primary-on-success)"
  },
  "colors.text.neutral.secondary": {
    "value": "var(--🐼-colors-text-neutral-secondary)",
    "variable": "var(--🐼-colors-text-neutral-secondary)"
  },
  "colors.text.neutral.secondary.alpha": {
    "value": "var(--🐼-colors-text-neutral-secondary-alpha)",
    "variable": "var(--🐼-colors-text-neutral-secondary-alpha)"
  },
  "colors.text.neutral.secondary.on.neutral": {
    "value": "var(--🐼-colors-text-neutral-secondary-on-neutral)",
    "variable": "var(--🐼-colors-text-neutral-secondary-on-neutral)"
  },
  "colors.text.neutral.tertiary": {
    "value": "var(--🐼-colors-text-neutral-tertiary)",
    "variable": "var(--🐼-colors-text-neutral-tertiary)"
  },
  "colors.text.neutral.tertiary.alpha": {
    "value": "var(--🐼-colors-text-neutral-tertiary-alpha)",
    "variable": "var(--🐼-colors-text-neutral-tertiary-alpha)"
  },
  "colors.text.neutral.tertiary.on.neutral": {
    "value": "var(--🐼-colors-text-neutral-tertiary-on-neutral)",
    "variable": "var(--🐼-colors-text-neutral-tertiary-on-neutral)"
  },
  "colors.text.neutral.placeholder": {
    "value": "var(--🐼-colors-text-neutral-placeholder)",
    "variable": "var(--🐼-colors-text-neutral-placeholder)"
  },
  "colors.text.neutral.placeholder.on.neutral": {
    "value": "var(--🐼-colors-text-neutral-placeholder-on-neutral)",
    "variable": "var(--🐼-colors-text-neutral-placeholder-on-neutral)"
  },
  "colors.text.accent.primary": {
    "value": "var(--🐼-colors-text-accent-primary)",
    "variable": "var(--🐼-colors-text-accent-primary)"
  },
  "colors.text.accent.secondary": {
    "value": "var(--🐼-colors-text-accent-secondary)",
    "variable": "var(--🐼-colors-text-accent-secondary)"
  },
  "colors.text.accent.tertiary": {
    "value": "var(--🐼-colors-text-accent-tertiary)",
    "variable": "var(--🐼-colors-text-accent-tertiary)"
  },
  "colors.text.critical.primary": {
    "value": "var(--🐼-colors-text-critical-primary)",
    "variable": "var(--🐼-colors-text-critical-primary)"
  },
  "colors.text.critical.secondary": {
    "value": "var(--🐼-colors-text-critical-secondary)",
    "variable": "var(--🐼-colors-text-critical-secondary)"
  },
  "colors.text.notice.primary": {
    "value": "var(--🐼-colors-text-notice-primary)",
    "variable": "var(--🐼-colors-text-notice-primary)"
  },
  "colors.text.notice.secondary": {
    "value": "var(--🐼-colors-text-notice-secondary)",
    "variable": "var(--🐼-colors-text-notice-secondary)"
  },
  "colors.text.success.primary": {
    "value": "var(--🐼-colors-text-success-primary)",
    "variable": "var(--🐼-colors-text-success-primary)"
  },
  "colors.text.success.secondary": {
    "value": "var(--🐼-colors-text-success-secondary)",
    "variable": "var(--🐼-colors-text-success-secondary)"
  },
  "colors.border.neutral.primary": {
    "value": "var(--🐼-colors-border-neutral-primary)",
    "variable": "var(--🐼-colors-border-neutral-primary)"
  },
  "colors.border.neutral.primary.alpha": {
    "value": "var(--🐼-colors-border-neutral-primary-alpha)",
    "variable": "var(--🐼-colors-border-neutral-primary-alpha)"
  },
  "colors.border.neutral.secondary": {
    "value": "var(--🐼-colors-border-neutral-secondary)",
    "variable": "var(--🐼-colors-border-neutral-secondary)"
  },
  "colors.border.neutral.secondary.alpha": {
    "value": "var(--🐼-colors-border-neutral-secondary-alpha)",
    "variable": "var(--🐼-colors-border-neutral-secondary-alpha)"
  },
  "colors.border.neutral.tertiary": {
    "value": "var(--🐼-colors-border-neutral-tertiary)",
    "variable": "var(--🐼-colors-border-neutral-tertiary)"
  },
  "colors.border.neutral.tertiary.alpha": {
    "value": "var(--🐼-colors-border-neutral-tertiary-alpha)",
    "variable": "var(--🐼-colors-border-neutral-tertiary-alpha)"
  },
  "colors.border.accent.primary": {
    "value": "var(--🐼-colors-border-accent-primary)",
    "variable": "var(--🐼-colors-border-accent-primary)"
  },
  "colors.border.accent.primary.alpha": {
    "value": "var(--🐼-colors-border-accent-primary-alpha)",
    "variable": "var(--🐼-colors-border-accent-primary-alpha)"
  },
  "colors.border.accent.secondary": {
    "value": "var(--🐼-colors-border-accent-secondary)",
    "variable": "var(--🐼-colors-border-accent-secondary)"
  },
  "colors.border.accent.secondary.alpha": {
    "value": "var(--🐼-colors-border-accent-secondary-alpha)",
    "variable": "var(--🐼-colors-border-accent-secondary-alpha)"
  },
  "colors.border.accent.tertiary": {
    "value": "var(--🐼-colors-border-accent-tertiary)",
    "variable": "var(--🐼-colors-border-accent-tertiary)"
  },
  "colors.border.accent.tertiary.alpha": {
    "value": "var(--🐼-colors-border-accent-tertiary-alpha)",
    "variable": "var(--🐼-colors-border-accent-tertiary-alpha)"
  },
  "colors.border.critical.primary": {
    "value": "var(--🐼-colors-border-critical-primary)",
    "variable": "var(--🐼-colors-border-critical-primary)"
  },
  "colors.border.critical.primary.alpha": {
    "value": "var(--🐼-colors-border-critical-primary-alpha)",
    "variable": "var(--🐼-colors-border-critical-primary-alpha)"
  },
  "colors.border.critical.secondary": {
    "value": "var(--🐼-colors-border-critical-secondary)",
    "variable": "var(--🐼-colors-border-critical-secondary)"
  },
  "colors.border.critical.secondary.alpha": {
    "value": "var(--🐼-colors-border-critical-secondary-alpha)",
    "variable": "var(--🐼-colors-border-critical-secondary-alpha)"
  },
  "colors.border.critical.tertiary": {
    "value": "var(--🐼-colors-border-critical-tertiary)",
    "variable": "var(--🐼-colors-border-critical-tertiary)"
  },
  "colors.border.critical.tertiary.alpha": {
    "value": "var(--🐼-colors-border-critical-tertiary-alpha)",
    "variable": "var(--🐼-colors-border-critical-tertiary-alpha)"
  },
  "colors.border.notice.primary": {
    "value": "var(--🐼-colors-border-notice-primary)",
    "variable": "var(--🐼-colors-border-notice-primary)"
  },
  "colors.border.notice.primary.alpha": {
    "value": "var(--🐼-colors-border-notice-primary-alpha)",
    "variable": "var(--🐼-colors-border-notice-primary-alpha)"
  },
  "colors.border.notice.secondary": {
    "value": "var(--🐼-colors-border-notice-secondary)",
    "variable": "var(--🐼-colors-border-notice-secondary)"
  },
  "colors.border.notice.secondary.alpha": {
    "value": "var(--🐼-colors-border-notice-secondary-alpha)",
    "variable": "var(--🐼-colors-border-notice-secondary-alpha)"
  },
  "colors.border.notice.tertiary": {
    "value": "var(--🐼-colors-border-notice-tertiary)",
    "variable": "var(--🐼-colors-border-notice-tertiary)"
  },
  "colors.border.notice.tertiary.alpha": {
    "value": "var(--🐼-colors-border-notice-tertiary-alpha)",
    "variable": "var(--🐼-colors-border-notice-tertiary-alpha)"
  },
  "colors.border.success.primary": {
    "value": "var(--🐼-colors-border-success-primary)",
    "variable": "var(--🐼-colors-border-success-primary)"
  },
  "colors.border.success.primary.alpha": {
    "value": "var(--🐼-colors-border-success-primary-alpha)",
    "variable": "var(--🐼-colors-border-success-primary-alpha)"
  },
  "colors.border.success.secondary": {
    "value": "var(--🐼-colors-border-success-secondary)",
    "variable": "var(--🐼-colors-border-success-secondary)"
  },
  "colors.border.success.secondary.alpha": {
    "value": "var(--🐼-colors-border-success-secondary-alpha)",
    "variable": "var(--🐼-colors-border-success-secondary-alpha)"
  },
  "colors.border.success.tertiary": {
    "value": "var(--🐼-colors-border-success-tertiary)",
    "variable": "var(--🐼-colors-border-success-tertiary)"
  },
  "colors.border.success.tertiary.alpha": {
    "value": "var(--🐼-colors-border-success-tertiary-alpha)",
    "variable": "var(--🐼-colors-border-success-tertiary-alpha)"
  },
  "colors.colorPalette.50": {
    "value": "var(--🐼-colors-color-palette-50)",
    "variable": "var(--🐼-colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--🐼-colors-color-palette-100)",
    "variable": "var(--🐼-colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--🐼-colors-color-palette-200)",
    "variable": "var(--🐼-colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--🐼-colors-color-palette-300)",
    "variable": "var(--🐼-colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--🐼-colors-color-palette-400)",
    "variable": "var(--🐼-colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--🐼-colors-color-palette-500)",
    "variable": "var(--🐼-colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--🐼-colors-color-palette-600)",
    "variable": "var(--🐼-colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--🐼-colors-color-palette-700)",
    "variable": "var(--🐼-colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--🐼-colors-color-palette-800)",
    "variable": "var(--🐼-colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--🐼-colors-color-palette-900)",
    "variable": "var(--🐼-colors-color-palette-900)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--🐼-colors-color-palette-1000)",
    "variable": "var(--🐼-colors-color-palette-1000)"
  },
  "colors.colorPalette.1100": {
    "value": "var(--🐼-colors-color-palette-1100)",
    "variable": "var(--🐼-colors-color-palette-1100)"
  },
  "colors.colorPalette.1200": {
    "value": "var(--🐼-colors-color-palette-1200)",
    "variable": "var(--🐼-colors-color-palette-1200)"
  },
  "colors.colorPalette.1300": {
    "value": "var(--🐼-colors-color-palette-1300)",
    "variable": "var(--🐼-colors-color-palette-1300)"
  },
  "colors.colorPalette.1400": {
    "value": "var(--🐼-colors-color-palette-1400)",
    "variable": "var(--🐼-colors-color-palette-1400)"
  },
  "colors.colorPalette.1500": {
    "value": "var(--🐼-colors-color-palette-1500)",
    "variable": "var(--🐼-colors-color-palette-1500)"
  },
  "colors.colorPalette.50A": {
    "value": "var(--🐼-colors-color-palette-50-a)",
    "variable": "var(--🐼-colors-color-palette-50-a)"
  },
  "colors.colorPalette.100A": {
    "value": "var(--🐼-colors-color-palette-100-a)",
    "variable": "var(--🐼-colors-color-palette-100-a)"
  },
  "colors.colorPalette.200A": {
    "value": "var(--🐼-colors-color-palette-200-a)",
    "variable": "var(--🐼-colors-color-palette-200-a)"
  },
  "colors.colorPalette.300A": {
    "value": "var(--🐼-colors-color-palette-300-a)",
    "variable": "var(--🐼-colors-color-palette-300-a)"
  },
  "colors.colorPalette.400A": {
    "value": "var(--🐼-colors-color-palette-400-a)",
    "variable": "var(--🐼-colors-color-palette-400-a)"
  },
  "colors.colorPalette.1200A": {
    "value": "var(--🐼-colors-color-palette-1200-a)",
    "variable": "var(--🐼-colors-color-palette-1200-a)"
  },
  "colors.colorPalette.1300A": {
    "value": "var(--🐼-colors-color-palette-1300-a)",
    "variable": "var(--🐼-colors-color-palette-1300-a)"
  },
  "colors.colorPalette.1400A": {
    "value": "var(--🐼-colors-color-palette-1400-a)",
    "variable": "var(--🐼-colors-color-palette-1400-a)"
  },
  "colors.colorPalette.1500A": {
    "value": "var(--🐼-colors-color-palette-1500-a)",
    "variable": "var(--🐼-colors-color-palette-1500-a)"
  },
  "colors.colorPalette": {
    "value": "var(--🐼-colors-color-palette)",
    "variable": "var(--🐼-colors-color-palette)"
  },
  "colors.colorPalette.amber.1": {
    "value": "var(--🐼-colors-color-palette-amber-1)",
    "variable": "var(--🐼-colors-color-palette-amber-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--🐼-colors-color-palette-1)",
    "variable": "var(--🐼-colors-color-palette-1)"
  },
  "colors.colorPalette.amber.2": {
    "value": "var(--🐼-colors-color-palette-amber-2)",
    "variable": "var(--🐼-colors-color-palette-amber-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--🐼-colors-color-palette-2)",
    "variable": "var(--🐼-colors-color-palette-2)"
  },
  "colors.colorPalette.amber.3": {
    "value": "var(--🐼-colors-color-palette-amber-3)",
    "variable": "var(--🐼-colors-color-palette-amber-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--🐼-colors-color-palette-3)",
    "variable": "var(--🐼-colors-color-palette-3)"
  },
  "colors.colorPalette.amber.4": {
    "value": "var(--🐼-colors-color-palette-amber-4)",
    "variable": "var(--🐼-colors-color-palette-amber-4)"
  },
  "colors.colorPalette.4": {
    "value": "var(--🐼-colors-color-palette-4)",
    "variable": "var(--🐼-colors-color-palette-4)"
  },
  "colors.colorPalette.amber.5": {
    "value": "var(--🐼-colors-color-palette-amber-5)",
    "variable": "var(--🐼-colors-color-palette-amber-5)"
  },
  "colors.colorPalette.5": {
    "value": "var(--🐼-colors-color-palette-5)",
    "variable": "var(--🐼-colors-color-palette-5)"
  },
  "colors.colorPalette.amber.6": {
    "value": "var(--🐼-colors-color-palette-amber-6)",
    "variable": "var(--🐼-colors-color-palette-amber-6)"
  },
  "colors.colorPalette.6": {
    "value": "var(--🐼-colors-color-palette-6)",
    "variable": "var(--🐼-colors-color-palette-6)"
  },
  "colors.colorPalette.amber.7": {
    "value": "var(--🐼-colors-color-palette-amber-7)",
    "variable": "var(--🐼-colors-color-palette-amber-7)"
  },
  "colors.colorPalette.7": {
    "value": "var(--🐼-colors-color-palette-7)",
    "variable": "var(--🐼-colors-color-palette-7)"
  },
  "colors.colorPalette.amber.8": {
    "value": "var(--🐼-colors-color-palette-amber-8)",
    "variable": "var(--🐼-colors-color-palette-amber-8)"
  },
  "colors.colorPalette.8": {
    "value": "var(--🐼-colors-color-palette-8)",
    "variable": "var(--🐼-colors-color-palette-8)"
  },
  "colors.colorPalette.amber.1A": {
    "value": "var(--🐼-colors-color-palette-amber-1-a)",
    "variable": "var(--🐼-colors-color-palette-amber-1-a)"
  },
  "colors.colorPalette.1A": {
    "value": "var(--🐼-colors-color-palette-1-a)",
    "variable": "var(--🐼-colors-color-palette-1-a)"
  },
  "colors.colorPalette.amber.2A": {
    "value": "var(--🐼-colors-color-palette-amber-2-a)",
    "variable": "var(--🐼-colors-color-palette-amber-2-a)"
  },
  "colors.colorPalette.2A": {
    "value": "var(--🐼-colors-color-palette-2-a)",
    "variable": "var(--🐼-colors-color-palette-2-a)"
  },
  "colors.colorPalette.amber.3A": {
    "value": "var(--🐼-colors-color-palette-amber-3-a)",
    "variable": "var(--🐼-colors-color-palette-amber-3-a)"
  },
  "colors.colorPalette.3A": {
    "value": "var(--🐼-colors-color-palette-3-a)",
    "variable": "var(--🐼-colors-color-palette-3-a)"
  },
  "colors.colorPalette.amber.4A": {
    "value": "var(--🐼-colors-color-palette-amber-4-a)",
    "variable": "var(--🐼-colors-color-palette-amber-4-a)"
  },
  "colors.colorPalette.4A": {
    "value": "var(--🐼-colors-color-palette-4-a)",
    "variable": "var(--🐼-colors-color-palette-4-a)"
  },
  "colors.colorPalette.blue.1": {
    "value": "var(--🐼-colors-color-palette-blue-1)",
    "variable": "var(--🐼-colors-color-palette-blue-1)"
  },
  "colors.colorPalette.blue.2": {
    "value": "var(--🐼-colors-color-palette-blue-2)",
    "variable": "var(--🐼-colors-color-palette-blue-2)"
  },
  "colors.colorPalette.blue.3": {
    "value": "var(--🐼-colors-color-palette-blue-3)",
    "variable": "var(--🐼-colors-color-palette-blue-3)"
  },
  "colors.colorPalette.blue.4": {
    "value": "var(--🐼-colors-color-palette-blue-4)",
    "variable": "var(--🐼-colors-color-palette-blue-4)"
  },
  "colors.colorPalette.blue.5": {
    "value": "var(--🐼-colors-color-palette-blue-5)",
    "variable": "var(--🐼-colors-color-palette-blue-5)"
  },
  "colors.colorPalette.blue.6": {
    "value": "var(--🐼-colors-color-palette-blue-6)",
    "variable": "var(--🐼-colors-color-palette-blue-6)"
  },
  "colors.colorPalette.blue.7": {
    "value": "var(--🐼-colors-color-palette-blue-7)",
    "variable": "var(--🐼-colors-color-palette-blue-7)"
  },
  "colors.colorPalette.blue.8": {
    "value": "var(--🐼-colors-color-palette-blue-8)",
    "variable": "var(--🐼-colors-color-palette-blue-8)"
  },
  "colors.colorPalette.blue.1A": {
    "value": "var(--🐼-colors-color-palette-blue-1-a)",
    "variable": "var(--🐼-colors-color-palette-blue-1-a)"
  },
  "colors.colorPalette.blue.2A": {
    "value": "var(--🐼-colors-color-palette-blue-2-a)",
    "variable": "var(--🐼-colors-color-palette-blue-2-a)"
  },
  "colors.colorPalette.blue.3A": {
    "value": "var(--🐼-colors-color-palette-blue-3-a)",
    "variable": "var(--🐼-colors-color-palette-blue-3-a)"
  },
  "colors.colorPalette.blue.4A": {
    "value": "var(--🐼-colors-color-palette-blue-4-a)",
    "variable": "var(--🐼-colors-color-palette-blue-4-a)"
  },
  "colors.colorPalette.cyan.1": {
    "value": "var(--🐼-colors-color-palette-cyan-1)",
    "variable": "var(--🐼-colors-color-palette-cyan-1)"
  },
  "colors.colorPalette.cyan.2": {
    "value": "var(--🐼-colors-color-palette-cyan-2)",
    "variable": "var(--🐼-colors-color-palette-cyan-2)"
  },
  "colors.colorPalette.cyan.3": {
    "value": "var(--🐼-colors-color-palette-cyan-3)",
    "variable": "var(--🐼-colors-color-palette-cyan-3)"
  },
  "colors.colorPalette.cyan.4": {
    "value": "var(--🐼-colors-color-palette-cyan-4)",
    "variable": "var(--🐼-colors-color-palette-cyan-4)"
  },
  "colors.colorPalette.cyan.5": {
    "value": "var(--🐼-colors-color-palette-cyan-5)",
    "variable": "var(--🐼-colors-color-palette-cyan-5)"
  },
  "colors.colorPalette.cyan.6": {
    "value": "var(--🐼-colors-color-palette-cyan-6)",
    "variable": "var(--🐼-colors-color-palette-cyan-6)"
  },
  "colors.colorPalette.cyan.7": {
    "value": "var(--🐼-colors-color-palette-cyan-7)",
    "variable": "var(--🐼-colors-color-palette-cyan-7)"
  },
  "colors.colorPalette.cyan.8": {
    "value": "var(--🐼-colors-color-palette-cyan-8)",
    "variable": "var(--🐼-colors-color-palette-cyan-8)"
  },
  "colors.colorPalette.cyan.1A": {
    "value": "var(--🐼-colors-color-palette-cyan-1-a)",
    "variable": "var(--🐼-colors-color-palette-cyan-1-a)"
  },
  "colors.colorPalette.cyan.2A": {
    "value": "var(--🐼-colors-color-palette-cyan-2-a)",
    "variable": "var(--🐼-colors-color-palette-cyan-2-a)"
  },
  "colors.colorPalette.cyan.3A": {
    "value": "var(--🐼-colors-color-palette-cyan-3-a)",
    "variable": "var(--🐼-colors-color-palette-cyan-3-a)"
  },
  "colors.colorPalette.cyan.4A": {
    "value": "var(--🐼-colors-color-palette-cyan-4-a)",
    "variable": "var(--🐼-colors-color-palette-cyan-4-a)"
  },
  "colors.colorPalette.emerald.1": {
    "value": "var(--🐼-colors-color-palette-emerald-1)",
    "variable": "var(--🐼-colors-color-palette-emerald-1)"
  },
  "colors.colorPalette.emerald.2": {
    "value": "var(--🐼-colors-color-palette-emerald-2)",
    "variable": "var(--🐼-colors-color-palette-emerald-2)"
  },
  "colors.colorPalette.emerald.3": {
    "value": "var(--🐼-colors-color-palette-emerald-3)",
    "variable": "var(--🐼-colors-color-palette-emerald-3)"
  },
  "colors.colorPalette.emerald.4": {
    "value": "var(--🐼-colors-color-palette-emerald-4)",
    "variable": "var(--🐼-colors-color-palette-emerald-4)"
  },
  "colors.colorPalette.emerald.5": {
    "value": "var(--🐼-colors-color-palette-emerald-5)",
    "variable": "var(--🐼-colors-color-palette-emerald-5)"
  },
  "colors.colorPalette.emerald.6": {
    "value": "var(--🐼-colors-color-palette-emerald-6)",
    "variable": "var(--🐼-colors-color-palette-emerald-6)"
  },
  "colors.colorPalette.emerald.7": {
    "value": "var(--🐼-colors-color-palette-emerald-7)",
    "variable": "var(--🐼-colors-color-palette-emerald-7)"
  },
  "colors.colorPalette.emerald.8": {
    "value": "var(--🐼-colors-color-palette-emerald-8)",
    "variable": "var(--🐼-colors-color-palette-emerald-8)"
  },
  "colors.colorPalette.emerald.1A": {
    "value": "var(--🐼-colors-color-palette-emerald-1-a)",
    "variable": "var(--🐼-colors-color-palette-emerald-1-a)"
  },
  "colors.colorPalette.emerald.2A": {
    "value": "var(--🐼-colors-color-palette-emerald-2-a)",
    "variable": "var(--🐼-colors-color-palette-emerald-2-a)"
  },
  "colors.colorPalette.emerald.3A": {
    "value": "var(--🐼-colors-color-palette-emerald-3-a)",
    "variable": "var(--🐼-colors-color-palette-emerald-3-a)"
  },
  "colors.colorPalette.emerald.4A": {
    "value": "var(--🐼-colors-color-palette-emerald-4-a)",
    "variable": "var(--🐼-colors-color-palette-emerald-4-a)"
  },
  "colors.colorPalette.fuchsia.1": {
    "value": "var(--🐼-colors-color-palette-fuchsia-1)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-1)"
  },
  "colors.colorPalette.fuchsia.2": {
    "value": "var(--🐼-colors-color-palette-fuchsia-2)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-2)"
  },
  "colors.colorPalette.fuchsia.3": {
    "value": "var(--🐼-colors-color-palette-fuchsia-3)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-3)"
  },
  "colors.colorPalette.fuchsia.4": {
    "value": "var(--🐼-colors-color-palette-fuchsia-4)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-4)"
  },
  "colors.colorPalette.fuchsia.5": {
    "value": "var(--🐼-colors-color-palette-fuchsia-5)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-5)"
  },
  "colors.colorPalette.fuchsia.6": {
    "value": "var(--🐼-colors-color-palette-fuchsia-6)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-6)"
  },
  "colors.colorPalette.fuchsia.7": {
    "value": "var(--🐼-colors-color-palette-fuchsia-7)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-7)"
  },
  "colors.colorPalette.fuchsia.8": {
    "value": "var(--🐼-colors-color-palette-fuchsia-8)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-8)"
  },
  "colors.colorPalette.fuchsia.1A": {
    "value": "var(--🐼-colors-color-palette-fuchsia-1-a)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-1-a)"
  },
  "colors.colorPalette.fuchsia.2A": {
    "value": "var(--🐼-colors-color-palette-fuchsia-2-a)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-2-a)"
  },
  "colors.colorPalette.fuchsia.3A": {
    "value": "var(--🐼-colors-color-palette-fuchsia-3-a)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-3-a)"
  },
  "colors.colorPalette.fuchsia.4A": {
    "value": "var(--🐼-colors-color-palette-fuchsia-4-a)",
    "variable": "var(--🐼-colors-color-palette-fuchsia-4-a)"
  },
  "colors.colorPalette.green.1": {
    "value": "var(--🐼-colors-color-palette-green-1)",
    "variable": "var(--🐼-colors-color-palette-green-1)"
  },
  "colors.colorPalette.green.2": {
    "value": "var(--🐼-colors-color-palette-green-2)",
    "variable": "var(--🐼-colors-color-palette-green-2)"
  },
  "colors.colorPalette.green.3": {
    "value": "var(--🐼-colors-color-palette-green-3)",
    "variable": "var(--🐼-colors-color-palette-green-3)"
  },
  "colors.colorPalette.green.4": {
    "value": "var(--🐼-colors-color-palette-green-4)",
    "variable": "var(--🐼-colors-color-palette-green-4)"
  },
  "colors.colorPalette.green.5": {
    "value": "var(--🐼-colors-color-palette-green-5)",
    "variable": "var(--🐼-colors-color-palette-green-5)"
  },
  "colors.colorPalette.green.6": {
    "value": "var(--🐼-colors-color-palette-green-6)",
    "variable": "var(--🐼-colors-color-palette-green-6)"
  },
  "colors.colorPalette.green.7": {
    "value": "var(--🐼-colors-color-palette-green-7)",
    "variable": "var(--🐼-colors-color-palette-green-7)"
  },
  "colors.colorPalette.green.8": {
    "value": "var(--🐼-colors-color-palette-green-8)",
    "variable": "var(--🐼-colors-color-palette-green-8)"
  },
  "colors.colorPalette.green.1A": {
    "value": "var(--🐼-colors-color-palette-green-1-a)",
    "variable": "var(--🐼-colors-color-palette-green-1-a)"
  },
  "colors.colorPalette.green.2A": {
    "value": "var(--🐼-colors-color-palette-green-2-a)",
    "variable": "var(--🐼-colors-color-palette-green-2-a)"
  },
  "colors.colorPalette.green.3A": {
    "value": "var(--🐼-colors-color-palette-green-3-a)",
    "variable": "var(--🐼-colors-color-palette-green-3-a)"
  },
  "colors.colorPalette.green.4A": {
    "value": "var(--🐼-colors-color-palette-green-4-a)",
    "variable": "var(--🐼-colors-color-palette-green-4-a)"
  },
  "colors.colorPalette.grey.1": {
    "value": "var(--🐼-colors-color-palette-grey-1)",
    "variable": "var(--🐼-colors-color-palette-grey-1)"
  },
  "colors.colorPalette.grey.2": {
    "value": "var(--🐼-colors-color-palette-grey-2)",
    "variable": "var(--🐼-colors-color-palette-grey-2)"
  },
  "colors.colorPalette.grey.3": {
    "value": "var(--🐼-colors-color-palette-grey-3)",
    "variable": "var(--🐼-colors-color-palette-grey-3)"
  },
  "colors.colorPalette.grey.4": {
    "value": "var(--🐼-colors-color-palette-grey-4)",
    "variable": "var(--🐼-colors-color-palette-grey-4)"
  },
  "colors.colorPalette.grey.5": {
    "value": "var(--🐼-colors-color-palette-grey-5)",
    "variable": "var(--🐼-colors-color-palette-grey-5)"
  },
  "colors.colorPalette.grey.6": {
    "value": "var(--🐼-colors-color-palette-grey-6)",
    "variable": "var(--🐼-colors-color-palette-grey-6)"
  },
  "colors.colorPalette.grey.7": {
    "value": "var(--🐼-colors-color-palette-grey-7)",
    "variable": "var(--🐼-colors-color-palette-grey-7)"
  },
  "colors.colorPalette.grey.8": {
    "value": "var(--🐼-colors-color-palette-grey-8)",
    "variable": "var(--🐼-colors-color-palette-grey-8)"
  },
  "colors.colorPalette.grey.1A": {
    "value": "var(--🐼-colors-color-palette-grey-1-a)",
    "variable": "var(--🐼-colors-color-palette-grey-1-a)"
  },
  "colors.colorPalette.grey.2A": {
    "value": "var(--🐼-colors-color-palette-grey-2-a)",
    "variable": "var(--🐼-colors-color-palette-grey-2-a)"
  },
  "colors.colorPalette.grey.3A": {
    "value": "var(--🐼-colors-color-palette-grey-3-a)",
    "variable": "var(--🐼-colors-color-palette-grey-3-a)"
  },
  "colors.colorPalette.grey.4A": {
    "value": "var(--🐼-colors-color-palette-grey-4-a)",
    "variable": "var(--🐼-colors-color-palette-grey-4-a)"
  },
  "colors.colorPalette.indigo.1": {
    "value": "var(--🐼-colors-color-palette-indigo-1)",
    "variable": "var(--🐼-colors-color-palette-indigo-1)"
  },
  "colors.colorPalette.indigo.2": {
    "value": "var(--🐼-colors-color-palette-indigo-2)",
    "variable": "var(--🐼-colors-color-palette-indigo-2)"
  },
  "colors.colorPalette.indigo.3": {
    "value": "var(--🐼-colors-color-palette-indigo-3)",
    "variable": "var(--🐼-colors-color-palette-indigo-3)"
  },
  "colors.colorPalette.indigo.4": {
    "value": "var(--🐼-colors-color-palette-indigo-4)",
    "variable": "var(--🐼-colors-color-palette-indigo-4)"
  },
  "colors.colorPalette.indigo.5": {
    "value": "var(--🐼-colors-color-palette-indigo-5)",
    "variable": "var(--🐼-colors-color-palette-indigo-5)"
  },
  "colors.colorPalette.indigo.6": {
    "value": "var(--🐼-colors-color-palette-indigo-6)",
    "variable": "var(--🐼-colors-color-palette-indigo-6)"
  },
  "colors.colorPalette.indigo.7": {
    "value": "var(--🐼-colors-color-palette-indigo-7)",
    "variable": "var(--🐼-colors-color-palette-indigo-7)"
  },
  "colors.colorPalette.indigo.8": {
    "value": "var(--🐼-colors-color-palette-indigo-8)",
    "variable": "var(--🐼-colors-color-palette-indigo-8)"
  },
  "colors.colorPalette.indigo.1A": {
    "value": "var(--🐼-colors-color-palette-indigo-1-a)",
    "variable": "var(--🐼-colors-color-palette-indigo-1-a)"
  },
  "colors.colorPalette.indigo.2A": {
    "value": "var(--🐼-colors-color-palette-indigo-2-a)",
    "variable": "var(--🐼-colors-color-palette-indigo-2-a)"
  },
  "colors.colorPalette.indigo.3A": {
    "value": "var(--🐼-colors-color-palette-indigo-3-a)",
    "variable": "var(--🐼-colors-color-palette-indigo-3-a)"
  },
  "colors.colorPalette.indigo.4A": {
    "value": "var(--🐼-colors-color-palette-indigo-4-a)",
    "variable": "var(--🐼-colors-color-palette-indigo-4-a)"
  },
  "colors.colorPalette.lime.1": {
    "value": "var(--🐼-colors-color-palette-lime-1)",
    "variable": "var(--🐼-colors-color-palette-lime-1)"
  },
  "colors.colorPalette.lime.2": {
    "value": "var(--🐼-colors-color-palette-lime-2)",
    "variable": "var(--🐼-colors-color-palette-lime-2)"
  },
  "colors.colorPalette.lime.3": {
    "value": "var(--🐼-colors-color-palette-lime-3)",
    "variable": "var(--🐼-colors-color-palette-lime-3)"
  },
  "colors.colorPalette.lime.4": {
    "value": "var(--🐼-colors-color-palette-lime-4)",
    "variable": "var(--🐼-colors-color-palette-lime-4)"
  },
  "colors.colorPalette.lime.5": {
    "value": "var(--🐼-colors-color-palette-lime-5)",
    "variable": "var(--🐼-colors-color-palette-lime-5)"
  },
  "colors.colorPalette.lime.6": {
    "value": "var(--🐼-colors-color-palette-lime-6)",
    "variable": "var(--🐼-colors-color-palette-lime-6)"
  },
  "colors.colorPalette.lime.7": {
    "value": "var(--🐼-colors-color-palette-lime-7)",
    "variable": "var(--🐼-colors-color-palette-lime-7)"
  },
  "colors.colorPalette.lime.8": {
    "value": "var(--🐼-colors-color-palette-lime-8)",
    "variable": "var(--🐼-colors-color-palette-lime-8)"
  },
  "colors.colorPalette.lime.1A": {
    "value": "var(--🐼-colors-color-palette-lime-1-a)",
    "variable": "var(--🐼-colors-color-palette-lime-1-a)"
  },
  "colors.colorPalette.lime.2A": {
    "value": "var(--🐼-colors-color-palette-lime-2-a)",
    "variable": "var(--🐼-colors-color-palette-lime-2-a)"
  },
  "colors.colorPalette.lime.3A": {
    "value": "var(--🐼-colors-color-palette-lime-3-a)",
    "variable": "var(--🐼-colors-color-palette-lime-3-a)"
  },
  "colors.colorPalette.lime.4A": {
    "value": "var(--🐼-colors-color-palette-lime-4-a)",
    "variable": "var(--🐼-colors-color-palette-lime-4-a)"
  },
  "colors.colorPalette.magenta.1": {
    "value": "var(--🐼-colors-color-palette-magenta-1)",
    "variable": "var(--🐼-colors-color-palette-magenta-1)"
  },
  "colors.colorPalette.magenta.2": {
    "value": "var(--🐼-colors-color-palette-magenta-2)",
    "variable": "var(--🐼-colors-color-palette-magenta-2)"
  },
  "colors.colorPalette.magenta.3": {
    "value": "var(--🐼-colors-color-palette-magenta-3)",
    "variable": "var(--🐼-colors-color-palette-magenta-3)"
  },
  "colors.colorPalette.magenta.4": {
    "value": "var(--🐼-colors-color-palette-magenta-4)",
    "variable": "var(--🐼-colors-color-palette-magenta-4)"
  },
  "colors.colorPalette.magenta.5": {
    "value": "var(--🐼-colors-color-palette-magenta-5)",
    "variable": "var(--🐼-colors-color-palette-magenta-5)"
  },
  "colors.colorPalette.magenta.6": {
    "value": "var(--🐼-colors-color-palette-magenta-6)",
    "variable": "var(--🐼-colors-color-palette-magenta-6)"
  },
  "colors.colorPalette.magenta.7": {
    "value": "var(--🐼-colors-color-palette-magenta-7)",
    "variable": "var(--🐼-colors-color-palette-magenta-7)"
  },
  "colors.colorPalette.magenta.8": {
    "value": "var(--🐼-colors-color-palette-magenta-8)",
    "variable": "var(--🐼-colors-color-palette-magenta-8)"
  },
  "colors.colorPalette.magenta.1A": {
    "value": "var(--🐼-colors-color-palette-magenta-1-a)",
    "variable": "var(--🐼-colors-color-palette-magenta-1-a)"
  },
  "colors.colorPalette.magenta.2A": {
    "value": "var(--🐼-colors-color-palette-magenta-2-a)",
    "variable": "var(--🐼-colors-color-palette-magenta-2-a)"
  },
  "colors.colorPalette.magenta.3A": {
    "value": "var(--🐼-colors-color-palette-magenta-3-a)",
    "variable": "var(--🐼-colors-color-palette-magenta-3-a)"
  },
  "colors.colorPalette.magenta.4A": {
    "value": "var(--🐼-colors-color-palette-magenta-4-a)",
    "variable": "var(--🐼-colors-color-palette-magenta-4-a)"
  },
  "colors.colorPalette.orange.1": {
    "value": "var(--🐼-colors-color-palette-orange-1)",
    "variable": "var(--🐼-colors-color-palette-orange-1)"
  },
  "colors.colorPalette.orange.2": {
    "value": "var(--🐼-colors-color-palette-orange-2)",
    "variable": "var(--🐼-colors-color-palette-orange-2)"
  },
  "colors.colorPalette.orange.3": {
    "value": "var(--🐼-colors-color-palette-orange-3)",
    "variable": "var(--🐼-colors-color-palette-orange-3)"
  },
  "colors.colorPalette.orange.4": {
    "value": "var(--🐼-colors-color-palette-orange-4)",
    "variable": "var(--🐼-colors-color-palette-orange-4)"
  },
  "colors.colorPalette.orange.5": {
    "value": "var(--🐼-colors-color-palette-orange-5)",
    "variable": "var(--🐼-colors-color-palette-orange-5)"
  },
  "colors.colorPalette.orange.6": {
    "value": "var(--🐼-colors-color-palette-orange-6)",
    "variable": "var(--🐼-colors-color-palette-orange-6)"
  },
  "colors.colorPalette.orange.7": {
    "value": "var(--🐼-colors-color-palette-orange-7)",
    "variable": "var(--🐼-colors-color-palette-orange-7)"
  },
  "colors.colorPalette.orange.8": {
    "value": "var(--🐼-colors-color-palette-orange-8)",
    "variable": "var(--🐼-colors-color-palette-orange-8)"
  },
  "colors.colorPalette.orange.1A": {
    "value": "var(--🐼-colors-color-palette-orange-1-a)",
    "variable": "var(--🐼-colors-color-palette-orange-1-a)"
  },
  "colors.colorPalette.orange.2A": {
    "value": "var(--🐼-colors-color-palette-orange-2-a)",
    "variable": "var(--🐼-colors-color-palette-orange-2-a)"
  },
  "colors.colorPalette.orange.3A": {
    "value": "var(--🐼-colors-color-palette-orange-3-a)",
    "variable": "var(--🐼-colors-color-palette-orange-3-a)"
  },
  "colors.colorPalette.orange.4A": {
    "value": "var(--🐼-colors-color-palette-orange-4-a)",
    "variable": "var(--🐼-colors-color-palette-orange-4-a)"
  },
  "colors.colorPalette.peach.1": {
    "value": "var(--🐼-colors-color-palette-peach-1)",
    "variable": "var(--🐼-colors-color-palette-peach-1)"
  },
  "colors.colorPalette.peach.2": {
    "value": "var(--🐼-colors-color-palette-peach-2)",
    "variable": "var(--🐼-colors-color-palette-peach-2)"
  },
  "colors.colorPalette.peach.3": {
    "value": "var(--🐼-colors-color-palette-peach-3)",
    "variable": "var(--🐼-colors-color-palette-peach-3)"
  },
  "colors.colorPalette.peach.4": {
    "value": "var(--🐼-colors-color-palette-peach-4)",
    "variable": "var(--🐼-colors-color-palette-peach-4)"
  },
  "colors.colorPalette.peach.5": {
    "value": "var(--🐼-colors-color-palette-peach-5)",
    "variable": "var(--🐼-colors-color-palette-peach-5)"
  },
  "colors.colorPalette.peach.6": {
    "value": "var(--🐼-colors-color-palette-peach-6)",
    "variable": "var(--🐼-colors-color-palette-peach-6)"
  },
  "colors.colorPalette.peach.7": {
    "value": "var(--🐼-colors-color-palette-peach-7)",
    "variable": "var(--🐼-colors-color-palette-peach-7)"
  },
  "colors.colorPalette.peach.8": {
    "value": "var(--🐼-colors-color-palette-peach-8)",
    "variable": "var(--🐼-colors-color-palette-peach-8)"
  },
  "colors.colorPalette.peach.1A": {
    "value": "var(--🐼-colors-color-palette-peach-1-a)",
    "variable": "var(--🐼-colors-color-palette-peach-1-a)"
  },
  "colors.colorPalette.peach.2A": {
    "value": "var(--🐼-colors-color-palette-peach-2-a)",
    "variable": "var(--🐼-colors-color-palette-peach-2-a)"
  },
  "colors.colorPalette.peach.3A": {
    "value": "var(--🐼-colors-color-palette-peach-3-a)",
    "variable": "var(--🐼-colors-color-palette-peach-3-a)"
  },
  "colors.colorPalette.peach.4A": {
    "value": "var(--🐼-colors-color-palette-peach-4-a)",
    "variable": "var(--🐼-colors-color-palette-peach-4-a)"
  },
  "colors.colorPalette.pink.1": {
    "value": "var(--🐼-colors-color-palette-pink-1)",
    "variable": "var(--🐼-colors-color-palette-pink-1)"
  },
  "colors.colorPalette.pink.2": {
    "value": "var(--🐼-colors-color-palette-pink-2)",
    "variable": "var(--🐼-colors-color-palette-pink-2)"
  },
  "colors.colorPalette.pink.3": {
    "value": "var(--🐼-colors-color-palette-pink-3)",
    "variable": "var(--🐼-colors-color-palette-pink-3)"
  },
  "colors.colorPalette.pink.4": {
    "value": "var(--🐼-colors-color-palette-pink-4)",
    "variable": "var(--🐼-colors-color-palette-pink-4)"
  },
  "colors.colorPalette.pink.5": {
    "value": "var(--🐼-colors-color-palette-pink-5)",
    "variable": "var(--🐼-colors-color-palette-pink-5)"
  },
  "colors.colorPalette.pink.6": {
    "value": "var(--🐼-colors-color-palette-pink-6)",
    "variable": "var(--🐼-colors-color-palette-pink-6)"
  },
  "colors.colorPalette.pink.7": {
    "value": "var(--🐼-colors-color-palette-pink-7)",
    "variable": "var(--🐼-colors-color-palette-pink-7)"
  },
  "colors.colorPalette.pink.8": {
    "value": "var(--🐼-colors-color-palette-pink-8)",
    "variable": "var(--🐼-colors-color-palette-pink-8)"
  },
  "colors.colorPalette.pink.1A": {
    "value": "var(--🐼-colors-color-palette-pink-1-a)",
    "variable": "var(--🐼-colors-color-palette-pink-1-a)"
  },
  "colors.colorPalette.pink.2A": {
    "value": "var(--🐼-colors-color-palette-pink-2-a)",
    "variable": "var(--🐼-colors-color-palette-pink-2-a)"
  },
  "colors.colorPalette.pink.3A": {
    "value": "var(--🐼-colors-color-palette-pink-3-a)",
    "variable": "var(--🐼-colors-color-palette-pink-3-a)"
  },
  "colors.colorPalette.pink.4A": {
    "value": "var(--🐼-colors-color-palette-pink-4-a)",
    "variable": "var(--🐼-colors-color-palette-pink-4-a)"
  },
  "colors.colorPalette.purple.1": {
    "value": "var(--🐼-colors-color-palette-purple-1)",
    "variable": "var(--🐼-colors-color-palette-purple-1)"
  },
  "colors.colorPalette.purple.2": {
    "value": "var(--🐼-colors-color-palette-purple-2)",
    "variable": "var(--🐼-colors-color-palette-purple-2)"
  },
  "colors.colorPalette.purple.3": {
    "value": "var(--🐼-colors-color-palette-purple-3)",
    "variable": "var(--🐼-colors-color-palette-purple-3)"
  },
  "colors.colorPalette.purple.4": {
    "value": "var(--🐼-colors-color-palette-purple-4)",
    "variable": "var(--🐼-colors-color-palette-purple-4)"
  },
  "colors.colorPalette.purple.5": {
    "value": "var(--🐼-colors-color-palette-purple-5)",
    "variable": "var(--🐼-colors-color-palette-purple-5)"
  },
  "colors.colorPalette.purple.6": {
    "value": "var(--🐼-colors-color-palette-purple-6)",
    "variable": "var(--🐼-colors-color-palette-purple-6)"
  },
  "colors.colorPalette.purple.7": {
    "value": "var(--🐼-colors-color-palette-purple-7)",
    "variable": "var(--🐼-colors-color-palette-purple-7)"
  },
  "colors.colorPalette.purple.8": {
    "value": "var(--🐼-colors-color-palette-purple-8)",
    "variable": "var(--🐼-colors-color-palette-purple-8)"
  },
  "colors.colorPalette.purple.1A": {
    "value": "var(--🐼-colors-color-palette-purple-1-a)",
    "variable": "var(--🐼-colors-color-palette-purple-1-a)"
  },
  "colors.colorPalette.purple.2A": {
    "value": "var(--🐼-colors-color-palette-purple-2-a)",
    "variable": "var(--🐼-colors-color-palette-purple-2-a)"
  },
  "colors.colorPalette.purple.3A": {
    "value": "var(--🐼-colors-color-palette-purple-3-a)",
    "variable": "var(--🐼-colors-color-palette-purple-3-a)"
  },
  "colors.colorPalette.purple.4A": {
    "value": "var(--🐼-colors-color-palette-purple-4-a)",
    "variable": "var(--🐼-colors-color-palette-purple-4-a)"
  },
  "colors.colorPalette.red.1": {
    "value": "var(--🐼-colors-color-palette-red-1)",
    "variable": "var(--🐼-colors-color-palette-red-1)"
  },
  "colors.colorPalette.red.2": {
    "value": "var(--🐼-colors-color-palette-red-2)",
    "variable": "var(--🐼-colors-color-palette-red-2)"
  },
  "colors.colorPalette.red.3": {
    "value": "var(--🐼-colors-color-palette-red-3)",
    "variable": "var(--🐼-colors-color-palette-red-3)"
  },
  "colors.colorPalette.red.4": {
    "value": "var(--🐼-colors-color-palette-red-4)",
    "variable": "var(--🐼-colors-color-palette-red-4)"
  },
  "colors.colorPalette.red.5": {
    "value": "var(--🐼-colors-color-palette-red-5)",
    "variable": "var(--🐼-colors-color-palette-red-5)"
  },
  "colors.colorPalette.red.6": {
    "value": "var(--🐼-colors-color-palette-red-6)",
    "variable": "var(--🐼-colors-color-palette-red-6)"
  },
  "colors.colorPalette.red.7": {
    "value": "var(--🐼-colors-color-palette-red-7)",
    "variable": "var(--🐼-colors-color-palette-red-7)"
  },
  "colors.colorPalette.red.8": {
    "value": "var(--🐼-colors-color-palette-red-8)",
    "variable": "var(--🐼-colors-color-palette-red-8)"
  },
  "colors.colorPalette.red.1A": {
    "value": "var(--🐼-colors-color-palette-red-1-a)",
    "variable": "var(--🐼-colors-color-palette-red-1-a)"
  },
  "colors.colorPalette.red.2A": {
    "value": "var(--🐼-colors-color-palette-red-2-a)",
    "variable": "var(--🐼-colors-color-palette-red-2-a)"
  },
  "colors.colorPalette.red.3A": {
    "value": "var(--🐼-colors-color-palette-red-3-a)",
    "variable": "var(--🐼-colors-color-palette-red-3-a)"
  },
  "colors.colorPalette.red.4A": {
    "value": "var(--🐼-colors-color-palette-red-4-a)",
    "variable": "var(--🐼-colors-color-palette-red-4-a)"
  },
  "colors.colorPalette.teal.1": {
    "value": "var(--🐼-colors-color-palette-teal-1)",
    "variable": "var(--🐼-colors-color-palette-teal-1)"
  },
  "colors.colorPalette.teal.2": {
    "value": "var(--🐼-colors-color-palette-teal-2)",
    "variable": "var(--🐼-colors-color-palette-teal-2)"
  },
  "colors.colorPalette.teal.3": {
    "value": "var(--🐼-colors-color-palette-teal-3)",
    "variable": "var(--🐼-colors-color-palette-teal-3)"
  },
  "colors.colorPalette.teal.4": {
    "value": "var(--🐼-colors-color-palette-teal-4)",
    "variable": "var(--🐼-colors-color-palette-teal-4)"
  },
  "colors.colorPalette.teal.5": {
    "value": "var(--🐼-colors-color-palette-teal-5)",
    "variable": "var(--🐼-colors-color-palette-teal-5)"
  },
  "colors.colorPalette.teal.6": {
    "value": "var(--🐼-colors-color-palette-teal-6)",
    "variable": "var(--🐼-colors-color-palette-teal-6)"
  },
  "colors.colorPalette.teal.7": {
    "value": "var(--🐼-colors-color-palette-teal-7)",
    "variable": "var(--🐼-colors-color-palette-teal-7)"
  },
  "colors.colorPalette.teal.8": {
    "value": "var(--🐼-colors-color-palette-teal-8)",
    "variable": "var(--🐼-colors-color-palette-teal-8)"
  },
  "colors.colorPalette.teal.1A": {
    "value": "var(--🐼-colors-color-palette-teal-1-a)",
    "variable": "var(--🐼-colors-color-palette-teal-1-a)"
  },
  "colors.colorPalette.teal.2A": {
    "value": "var(--🐼-colors-color-palette-teal-2-a)",
    "variable": "var(--🐼-colors-color-palette-teal-2-a)"
  },
  "colors.colorPalette.teal.3A": {
    "value": "var(--🐼-colors-color-palette-teal-3-a)",
    "variable": "var(--🐼-colors-color-palette-teal-3-a)"
  },
  "colors.colorPalette.teal.4A": {
    "value": "var(--🐼-colors-color-palette-teal-4-a)",
    "variable": "var(--🐼-colors-color-palette-teal-4-a)"
  },
  "colors.colorPalette.violet.1": {
    "value": "var(--🐼-colors-color-palette-violet-1)",
    "variable": "var(--🐼-colors-color-palette-violet-1)"
  },
  "colors.colorPalette.violet.2": {
    "value": "var(--🐼-colors-color-palette-violet-2)",
    "variable": "var(--🐼-colors-color-palette-violet-2)"
  },
  "colors.colorPalette.violet.3": {
    "value": "var(--🐼-colors-color-palette-violet-3)",
    "variable": "var(--🐼-colors-color-palette-violet-3)"
  },
  "colors.colorPalette.violet.4": {
    "value": "var(--🐼-colors-color-palette-violet-4)",
    "variable": "var(--🐼-colors-color-palette-violet-4)"
  },
  "colors.colorPalette.violet.5": {
    "value": "var(--🐼-colors-color-palette-violet-5)",
    "variable": "var(--🐼-colors-color-palette-violet-5)"
  },
  "colors.colorPalette.violet.6": {
    "value": "var(--🐼-colors-color-palette-violet-6)",
    "variable": "var(--🐼-colors-color-palette-violet-6)"
  },
  "colors.colorPalette.violet.7": {
    "value": "var(--🐼-colors-color-palette-violet-7)",
    "variable": "var(--🐼-colors-color-palette-violet-7)"
  },
  "colors.colorPalette.violet.8": {
    "value": "var(--🐼-colors-color-palette-violet-8)",
    "variable": "var(--🐼-colors-color-palette-violet-8)"
  },
  "colors.colorPalette.violet.1A": {
    "value": "var(--🐼-colors-color-palette-violet-1-a)",
    "variable": "var(--🐼-colors-color-palette-violet-1-a)"
  },
  "colors.colorPalette.violet.2A": {
    "value": "var(--🐼-colors-color-palette-violet-2-a)",
    "variable": "var(--🐼-colors-color-palette-violet-2-a)"
  },
  "colors.colorPalette.violet.3A": {
    "value": "var(--🐼-colors-color-palette-violet-3-a)",
    "variable": "var(--🐼-colors-color-palette-violet-3-a)"
  },
  "colors.colorPalette.violet.4A": {
    "value": "var(--🐼-colors-color-palette-violet-4-a)",
    "variable": "var(--🐼-colors-color-palette-violet-4-a)"
  },
  "colors.colorPalette.yellow.1": {
    "value": "var(--🐼-colors-color-palette-yellow-1)",
    "variable": "var(--🐼-colors-color-palette-yellow-1)"
  },
  "colors.colorPalette.yellow.2": {
    "value": "var(--🐼-colors-color-palette-yellow-2)",
    "variable": "var(--🐼-colors-color-palette-yellow-2)"
  },
  "colors.colorPalette.yellow.3": {
    "value": "var(--🐼-colors-color-palette-yellow-3)",
    "variable": "var(--🐼-colors-color-palette-yellow-3)"
  },
  "colors.colorPalette.yellow.4": {
    "value": "var(--🐼-colors-color-palette-yellow-4)",
    "variable": "var(--🐼-colors-color-palette-yellow-4)"
  },
  "colors.colorPalette.yellow.5": {
    "value": "var(--🐼-colors-color-palette-yellow-5)",
    "variable": "var(--🐼-colors-color-palette-yellow-5)"
  },
  "colors.colorPalette.yellow.6": {
    "value": "var(--🐼-colors-color-palette-yellow-6)",
    "variable": "var(--🐼-colors-color-palette-yellow-6)"
  },
  "colors.colorPalette.yellow.7": {
    "value": "var(--🐼-colors-color-palette-yellow-7)",
    "variable": "var(--🐼-colors-color-palette-yellow-7)"
  },
  "colors.colorPalette.yellow.8": {
    "value": "var(--🐼-colors-color-palette-yellow-8)",
    "variable": "var(--🐼-colors-color-palette-yellow-8)"
  },
  "colors.colorPalette.yellow.1A": {
    "value": "var(--🐼-colors-color-palette-yellow-1-a)",
    "variable": "var(--🐼-colors-color-palette-yellow-1-a)"
  },
  "colors.colorPalette.yellow.2A": {
    "value": "var(--🐼-colors-color-palette-yellow-2-a)",
    "variable": "var(--🐼-colors-color-palette-yellow-2-a)"
  },
  "colors.colorPalette.yellow.3A": {
    "value": "var(--🐼-colors-color-palette-yellow-3-a)",
    "variable": "var(--🐼-colors-color-palette-yellow-3-a)"
  },
  "colors.colorPalette.yellow.4A": {
    "value": "var(--🐼-colors-color-palette-yellow-4-a)",
    "variable": "var(--🐼-colors-color-palette-yellow-4-a)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar